// @ts-nocheck
import { MOCK } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// __legacy_global_aliases__
// Resolve cross-module helpers via window (legacy SPA globals)
const renderOpsModuleTabs = (...args: any[]) => (window as any).renderOpsModuleTabs(...args);
const renderOpsWorkflowHint = (...args: any[]) => (window as any).renderOpsWorkflowHint(...args);


// ============================================================
// 数据分析：漏斗 / 渠道对比 / 趋势 / 用户路径 / 数据导出
// 新视觉版：渐变图表 + 专业 tooltip + 玻璃拟态卡
// ============================================================

window.Pages = window.Pages || {};

// ---------- LTV 分析说明页 ----------
Pages.ltvAnalysis = function () {
  const scheme1Steps = [
    ["阶段一：SDK 生成 Code 并绑定 App 侧用户", "老用户在 App 内触发分享，Share SDK 生成 ShareCode，并同步给 App 后端记录分享者 UID 与 ShareCode 的关系。"],
    ["阶段二：分享 URL 携带参数完成应用商店传递", "ShareCode 拼接到 H5 / URL 参数中，用户点击后跳转 Google Play，并通过 Referrer 继续传递。"],
    ["阶段三：安装后 SDK 取回参数", "新用户安装并启动后，Share SDK 读取 Referrer，取回 ShareCode 并回调给新 App。"],
    ["阶段四：游戏自有库完成 LTV 分析", "游戏客户端拿到新用户 UID，将新用户 UID + ShareCode 提交游戏后端；游戏在自有数据库按用户维度、运营活动维度分析 LTV。"],
  ];
  const scheme2Steps = [
    ["阶段一：分享时传入老用户 UID", "老用户拉起分享时，游戏客户端调用 Share SDK，并传入分享者 UID、运营活动信息、包体和渠道上下文。"],
    ["阶段二：SDK 生成并透传归因参数", "EasyShare 生成可追踪的 ShareCode / sdkUID，随分享链接、H5 跳转和应用商店 Referrer 一路传递到新安装。"],
    ["阶段三：新用户下载成功后传入 sdkUID", "新用户安装并完成初始化后，游戏客户端再次调用 Share SDK，传入新下载用户 UID 与本次 sdkUID。"],
    ["阶段四：EasyShare 记录新下载 UID 日志", "EasyShare 存储分享者 UID、新下载 UID、活动配置、渠道、包体、Region、Platform、时间等日志，供运营后续离线分析。"],
  ];
  const schemeCompare = [
    ["归因数据存储", "游戏自有数据库", "EasyShare 存储新下载 UID 日志"],
    ["游戏侧接入", "接收 SDK 回调 ShareCode，并自行入库", "分享时传入 UID，新下载成功时传入 sdkUID / 新用户 UID"],
    ["运营分析方式", "游戏侧按用户和运营活动维度自行分析", "运营从 EasyShare 日志表获取用户和活动维度数据后分析"],
    ["本期页面能力", "仅展示方案，不提供在线分析", "仅展示方案，不提供日志下载功能"],
  ];

  const renderSequence = (title, subtitle, actors, steps, color = "brand") => `
    <div class="rounded-xl border border-ink-100 bg-white overflow-hidden">
      <div class="px-4 py-3 border-b border-ink-100 bg-${color}-50/60">
        <div class="text-sm font-semibold text-ink-900">${title}</div>
        <div class="text-xs text-ink-500 mt-0.5">${subtitle}</div>
      </div>
      <div class="p-4 overflow-x-auto">
        <div class="min-w-[920px]">
          <div class="grid gap-3 mb-3" style="grid-template-columns: repeat(${actors.length}, minmax(0, 1fr));">
            ${actors.map((actor) => `<div class="rounded-lg border border-ink-100 bg-ink-50 px-3 py-2 text-center text-xs font-semibold text-ink-700">${actor}</div>`).join("")}
          </div>
          <div class="relative grid gap-3 pb-2" style="grid-template-columns: repeat(${actors.length}, minmax(0, 1fr));">
            ${actors.map(() => `<div class="h-full min-h-[360px] border-l border-dashed border-ink-200 mx-auto"></div>`).join("")}
            <div class="absolute inset-x-0 top-0 space-y-3">
              ${steps.map((step, idx) => `
                <div class="mx-2 rounded-lg border border-ink-100 bg-white/95 shadow-soft px-4 py-3">
                  <div class="flex items-start gap-3">
                    <span class="w-6 h-6 rounded-full bg-brand-900 text-white text-[11px] font-semibold flex items-center justify-center flex-shrink-0">${idx + 1}</span>
                    <div>
                      <div class="text-xs font-semibold text-ink-900">${step[0]}</div>
                      <div class="text-xs text-ink-500 leading-relaxed mt-1">${step[1]}</div>
                    </div>
                  </div>
                </div>
              `).join("")}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  return `
    ${UI.pageHeader({
      title: "LTV分析",
      desc: "本页为静态说明页，用于向运营说明 EasyShare 当前支持 LTV 分析的两种接入方案；本期不提供在线分析、日志下载或报表导出功能。",
    })}


    <div class="grid grid-cols-2 gap-5 mb-5">
      <div class="card p-5">
        <div class="flex items-center justify-between gap-3">
          <div>
            <div class="text-sm font-semibold text-ink-900">方案 1：ShareCode 透传，游戏自有库分析</div>
            <div class="text-xs text-ink-500 mt-1">适合游戏已有用户行为、付费和活动数据库，希望自己完成 LTV 建模。</div>
          </div>
          <span class="badge bg-brand-50 text-brand-700">游戏侧分析</span>
        </div>
        <div class="mt-4 space-y-2 text-xs text-ink-600 leading-relaxed">
          <div>Share SDK 接收客户端生成/传出的码，将 ShareCode 一路透传到新用户安装后的客户端。</div>
          <div>新客户端收到 ShareCode 后，游戏可把新用户 UID 与 ShareCode 回传到自有后端，在自有数据库中按用户维度、运营活动维度做 LTV 分析。</div>
        </div>
      </div>

      <div class="card p-5">
        <div class="flex items-center justify-between gap-3">
          <div>
            <div class="text-sm font-semibold text-ink-900">方案 2：UID / sdkUID 日志，EasyShare 存储归因记录</div>
            <div class="text-xs text-ink-500 mt-1">适合希望 EasyShare 生成用户与活动归因日志，后续离线取数分析。</div>
          </div>
          <span class="badge bg-ok-50 text-ok-700">日志支持</span>
        </div>
        <div class="mt-4 space-y-2 text-xs text-ink-600 leading-relaxed">
          <div>游戏客户端在拉起分享时传入分享者 UID；新下载成功后，再向 SDK 传入新用户 UID / sdkUID。</div>
          <div>EasyShare 可存储用户维度和运营活动维度的新下载 UID 日志，未来运营可基于日志表进行 LTV 分析。</div>
        </div>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100">
        <div class="text-sm font-semibold text-ink-900">两种支持方案对比</div>
        <div class="text-xs text-ink-500 mt-1">帮助运营和研发判断当前游戏更适合采用哪种 LTV 分析链路。</div>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-5 py-2.5 font-medium w-40">对比项</th>
            <th class="text-left px-5 py-2.5 font-medium">方案 1</th>
            <th class="text-left px-5 py-2.5 font-medium">方案 2</th>
          </tr>
        </thead>
        <tbody>
          ${schemeCompare.map(([label, s1, s2]) => `
            <tr class="border-t border-ink-100 align-top">
              <td class="px-5 py-3 font-medium text-ink-900">${label}</td>
              <td class="px-5 py-3 text-ink-600 leading-relaxed">${s1}</td>
              <td class="px-5 py-3 text-ink-600 leading-relaxed">${s2}</td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </div>

    <div class="space-y-5 mb-5">
      <div class="rounded-xl border border-ink-100 bg-white overflow-hidden">
        <div class="px-4 py-3 border-b border-ink-100 bg-brand-50/60">
          <div class="text-sm font-semibold text-ink-900">方案 1 时序图：ShareCode 透传到游戏自有数据库</div>
          <div class="text-xs text-ink-500 mt-0.5">使用方案 1 原始时序图，EasyShare 负责码生成与透传，LTV 分析由游戏自有库完成。</div>
        </div>
        <div class="p-4 overflow-x-auto bg-white">
          <img src="/assets/ltv-scheme1-sequence.svg" alt="方案 1 ShareCode 透传时序图" class="min-w-[920px] w-full rounded-lg border border-ink-100 bg-white" />
        </div>
      </div>
      <div class="rounded-xl border border-ink-100 bg-white overflow-hidden">
        <div class="px-4 py-3 border-b border-ink-100 bg-ok-50/60">
          <div class="text-sm font-semibold text-ink-900">方案 2 时序图：UID / sdkUID 日志沉淀到 EasyShare</div>
          <div class="text-xs text-ink-500 mt-0.5">参照方案 1 的链路结构，新增分享者 UID、新下载 UID 与 sdkUID 的日志写入。</div>
        </div>
        <div class="p-4 overflow-x-auto bg-white">
          <img src="/assets/ltv-scheme2-sequence.svg" alt="方案 2 UID 与 sdkUID 日志沉淀时序图" class="min-w-[920px] w-full rounded-lg border border-ink-100 bg-white" />
        </div>
      </div>
    </div>
  `;
};

// ---------- 运营数据概览 ----------
Pages.analyticsOverview = function () {
  const selectedGame = getAnalyticsSelectedGame();
  const selectedGameId = selectedGame?.id || MOCK.GAMES[0]?.id || "";
  const gamePackages = getAnalyticsGamePackages(selectedGameId);
  const metrics = buildAnalyticsOverviewMetrics(gamePackages);
  PageHooks.mounted = () => scheduleAnalyticsOverviewCharts();
  return `
    ${UI.pageHeader({
      title: "数据概览",
      desc: "",
    })}

    <div class="card p-4 mb-5">
      <div class="grid grid-cols-12 gap-3 items-end">
        <label class="col-span-3 block relative">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">时间</span>
          <button type="button" onclick="toggleAnalyticsCustomTime()" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white text-left flex items-center justify-between gap-2 hover:border-brand-300">
            <span id="analytics-overview-time-label" class="truncate">最近 7 天</span>
            <span class="text-ink-400">⌄</span>
          </button>
          <div id="analytics-overview-custom-time" class="hidden absolute left-0 top-full mt-2 w-[420px] z-20 rounded-xl border border-ink-200 bg-white shadow-pop p-3">
            <div class="grid grid-cols-4 gap-2 mb-3">
              ${["今天", "昨天", "最近 7 天", "最近 30 天"].map((item) => `<button type="button" onclick="setAnalyticsTimePreset('${item}')" class="px-2.5 py-2 text-xs rounded-lg border border-ink-100 hover:bg-ink-50">${item}</button>`).join("")}
            </div>
            <div class="grid grid-cols-2 gap-3">
              <div>
                <span class="block text-xs font-medium text-ink-500 mb-1.5">开始时间</span>
                <input id="analytics-overview-custom-start" type="date" value="2026-05-30" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white" />
              </div>
              <div>
                <span class="block text-xs font-medium text-ink-500 mb-1.5">结束时间</span>
                <input id="analytics-overview-custom-end" type="date" value="2026-06-05" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white" />
              </div>
            </div>
            <div class="mt-3 flex justify-end">
              <button type="button" onclick="applyAnalyticsCustomTime()" class="px-3 py-1.5 text-xs rounded-lg bg-brand-900 text-white hover:bg-brand-800">确定</button>
            </div>
          </div>
        </label>
        <label class="col-span-3 block">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">游戏</span>
          <select id="analytics-overview-game-filter" onchange="changeAnalyticsOverviewGame(this.value)" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white">
            ${MOCK.GAMES.filter((g) => g.status === "active").map((g) => `<option value="${g.id}" ${g.id === selectedGameId ? "selected" : ""}>${g.name}</option>`).join("")}
          </select>
        </label>
        <div class="col-span-4 block relative">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">包体（可多选）</span>
          <button type="button" onclick="toggleAnalyticsOverviewPackagePanel()" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white text-left flex items-center justify-between gap-2 hover:border-brand-300">
            <span id="analytics-overview-package-label" class="truncate">全部包体</span>
            <span class="text-ink-400">⌄</span>
          </button>
          <div id="analytics-overview-package-panel" class="hidden absolute left-0 right-0 top-full mt-2 z-20 rounded-xl border border-ink-200 bg-white shadow-pop overflow-hidden">
            <div class="px-3 py-2 border-b border-ink-100 flex items-center justify-between gap-2 bg-ink-50">
              <span class="text-xs font-semibold text-ink-700">选择统计包体</span>
              <div class="flex items-center gap-3 text-xs">
                <button type="button" onclick="selectAllAnalyticsOverviewPackages()" class="text-brand-700 hover:underline">全选</button>
                <button type="button" onclick="clearAnalyticsOverviewPackages()" class="text-ink-500 hover:underline">清空</button>
              </div>
            </div>
            <div class="max-h-56 overflow-auto p-2 space-y-1">
              ${gamePackages.map((p) => `
                <label class="flex items-start gap-2 rounded-lg px-2.5 py-2 text-xs hover:bg-ink-50 cursor-pointer">
                  <input type="checkbox" data-analytics-overview-package="${p.id}" data-label="${p.name}" onchange="updateAnalyticsOverviewPackageLabel()" class="mt-0.5 rounded border-ink-300" />
                  <span class="min-w-0">
                    <span class="block font-medium text-ink-800 truncate">${p.name}</span>
                    <span class="block text-[11px] text-ink-400 truncate">${p.region || "GLOBAL"} · ${p.platform || "Platform"}</span>
                  </span>
                </label>
              `).join("")}
            </div>
            <div class="px-3 py-2 border-t border-ink-100 flex items-center justify-between gap-2">
              <span class="text-[11px] text-ink-400">不选择时默认统计当前游戏全部包体</span>
              <button type="button" onclick="confirmAnalyticsOverviewPackages()" class="px-3 py-1.5 text-xs rounded-lg bg-brand-900 text-white hover:bg-brand-800">确认包体</button>
            </div>
          </div>
        </div>
        <div class="col-span-2 flex justify-end gap-2">
          <button onclick="resetAnalyticsOverviewFilters()" class="px-4 py-2.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">重置</button>
          <button onclick="applyAnalyticsOverviewFilters()" class="px-4 py-2.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">确认</button>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-2 mb-5">
      <div class="col-span-7 rounded-xl border border-ink-100 bg-white p-2">
        <div class="mb-2 flex items-center justify-between px-1">
          <span class="text-xs font-semibold text-ink-700">绝对数量</span>
          <span class="text-[10px] text-ink-400">直接聚合分享明细</span>
        </div>
        <div class="grid grid-cols-7 gap-2">
          ${renderAnalyticsOverviewMetric("总分享数", UI.fmtNum(metrics.share), "+12.4%", "聚合", "brand", "count")}
          ${renderAnalyticsOverviewMetric("总打开数", UI.fmtNum(metrics.open), "+10.8%", "打开", "blue", "count")}
          ${renderAnalyticsOverviewMetric("点击安装数", UI.fmtNum(metrics.installStart), "+8.6%", "安装点击", "green", "count")}
          ${renderAnalyticsOverviewMetric("成功安装数", UI.fmtNum(metrics.installSuccess), "+6.2%", "安装成功", "green", "count")}
          ${renderAnalyticsOverviewMetric("点击回流数", UI.fmtNum(metrics.reflowStart), "+5.4%", "回流点击", "amber", "count")}
          ${renderAnalyticsOverviewMetric("成功回流数", UI.fmtNum(metrics.reflowSuccess), "+4.1%", "回流成功", "rose", "count")}
          ${renderAnalyticsOverviewMetric("分享配置数", `${metrics.configCount} 条`, "当前", "配置数", "blue", "count")}
        </div>
      </div>
      <div class="col-span-5 rounded-xl border border-brand-100 bg-brand-50/30 p-2">
        <div class="mb-2 flex items-center justify-between px-1">
          <span class="text-xs font-semibold text-brand-700">转化率</span>
          <span class="text-[10px] text-brand-500">按相邻链路计算</span>
        </div>
        <div class="grid grid-cols-5 gap-2">
          ${renderAnalyticsOverviewMetric("打开转化率", `${metrics.openRate}%`, "+1.6%", "打开/分享", "ok", "rate")}
          ${renderAnalyticsOverviewMetric("点击安装率", `${metrics.installClickRate}%`, "+1.2%", "点击安装/打开", "amber", "rate")}
          ${renderAnalyticsOverviewMetric("成功安装率", `${metrics.installSuccessRate}%`, "+0.9%", "成功安装/点击", "ok", "rate")}
          ${renderAnalyticsOverviewMetric("点击回流率", `${metrics.reflowClickRate}%`, "+0.7%", "点击回流/打开", "brand", "rate")}
          ${renderAnalyticsOverviewMetric("成功回流率", `${metrics.reflowSuccessRate}%`, "+0.5%", "成功回流/点击", "green", "rate")}
        </div>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">核心指标趋势</h3>

        </div>
        <span class="badge bg-brand-50 text-brand-700">时间维度</span>
      </div>
      <div id="analytics-overview-trend" class="h-[300px]"></div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-4">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">${selectedGame?.name || "当前游戏"} 分布饼图</h3>

        </div>
        <label class="flex items-center gap-2 text-xs text-ink-500">
          指标
          <select id="analytics-overview-pie-metric" onchange="renderAnalyticsOverviewCharts()" class="px-3 py-2 text-sm border border-ink-200 rounded-lg bg-white text-ink-700">
            <option value="share">总分享数</option>
            <option value="open">总打开数</option>
            <option value="installStart">点击安装数</option>
            <option value="installSuccess">成功安装数</option>
            <option value="reflowStart">点击回流数</option>
            <option value="reflowSuccess">成功回流数</option>
          </select>
        </label>
      </div>
      <div class="grid grid-cols-3 divide-x divide-ink-100">
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">包体分布</div>
          <div id="analytics-overview-package-pie" class="h-[300px]"></div>
        </div>
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">区域分布</div>
          <div id="analytics-overview-region-pie" class="h-[300px]"></div>
        </div>
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">平台分布</div>
          <div id="analytics-overview-platform-pie" class="h-[300px]"></div>
        </div>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-4">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">用户设备分布</h3>
          <p class="text-xs text-ink-500 mt-0.5">按当前筛选指标统计系统语言、手机型号、操作系统版本和运行内存。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">跟随上方指标</span>
      </div>
      <div class="grid grid-cols-4 divide-x divide-ink-100">
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">系统语言分布</div>
          <div id="analytics-overview-language-pie" class="h-[260px]"></div>
        </div>
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">手机型号分布</div>
          <div id="analytics-overview-device-model-pie" class="h-[260px]"></div>
        </div>
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">操作系统版本分布</div>
          <div id="analytics-overview-os-version-pie" class="h-[260px]"></div>
        </div>
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">运行内存分布</div>
          <div id="analytics-overview-memory-pie" class="h-[260px]"></div>
        </div>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-4">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">有分享的玩家特征分布</h3>
          <p class="text-xs text-ink-500 mt-0.5">仅统计产生过分享行为的玩家，拆分分享频次、安装时长和活跃程度。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">跟随上方指标</span>
      </div>
      <div class="grid grid-cols-3 divide-x divide-ink-100">
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">频次分布</div>
          <div id="analytics-overview-share-frequency-pie" class="h-[280px]"></div>
        </div>
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">安装分布</div>
          <div id="analytics-overview-install-age-pie" class="h-[280px]"></div>
        </div>
        <div class="p-4">
          <div class="text-sm font-semibold text-ink-900">活跃分布</div>
          <div id="analytics-overview-active-level-pie" class="h-[280px]"></div>
        </div>
      </div>
    </div>

    <div class="space-y-5">
      ${renderAnalyticsRankTable("包体排行", getAnalyticsPackageRankRows(gamePackages), "包体", "区域")}
      ${renderAnalyticsRankTable("区域排行", buildAnalyticsRegionRows(gamePackages), "区域", "包体数")}
      ${renderAnalyticsRankTable("平台排行", buildAnalyticsPlatformRankRows(gamePackages), "平台", "包体数")}
      ${renderAnalyticsRankTable("语言排行", buildAnalyticsLanguageRankRows(gamePackages), "语言", "语言代码")}
    </div>
  `;
};

window.toggleAnalyticsCustomTime = function (forceShow) {
  const panel = document.getElementById("analytics-overview-custom-time");
  if (!panel) return;
  const shouldShow = typeof forceShow === "boolean" ? forceShow : panel.classList.contains("hidden");
  panel.classList.toggle("hidden", !shouldShow);
};

window.setAnalyticsTimePreset = function (label) {
  const target = document.getElementById("analytics-overview-time-label");
  if (target) target.textContent = label;
  toggleAnalyticsCustomTime(false);
};

window.applyAnalyticsCustomTime = function () {
  const start = document.getElementById("analytics-overview-custom-start")?.value || "";
  const end = document.getElementById("analytics-overview-custom-end")?.value || "";
  const target = document.getElementById("analytics-overview-time-label");
  if (!target || !start || !end) return;
  target.textContent = `${start} 至 ${end}`;
  toggleAnalyticsCustomTime(false);
};

window.changeAnalyticsOverviewGame = function (gameId) {
  navigate(`/ops/analytics/overview?game=${encodeURIComponent(gameId || "")}`);
};

window.changeShareDataDetailsGame = function (gameId) {
  navigate(`/ops/analytics/share-details?game=${encodeURIComponent(gameId || "")}`);
};

function getAnalyticsOverviewSelectedPackageIds() {
  return Array.from(document.querySelectorAll("[data-analytics-overview-package]:checked")).map((item) => item.dataset.analyticsOverviewPackage || item.value || "").filter(Boolean);
}

window.toggleAnalyticsOverviewPackagePanel = function (forceShow) {
  const panel = document.getElementById("analytics-overview-package-panel");
  if (!panel) return;
  const shouldShow = typeof forceShow === "boolean" ? forceShow : panel.classList.contains("hidden");
  panel.classList.toggle("hidden", !shouldShow);
};

window.updateAnalyticsOverviewPackageLabel = function () {
  const label = document.getElementById("analytics-overview-package-label");
  if (!label) return;
  const checked = Array.from(document.querySelectorAll("[data-analytics-overview-package]:checked")).map((item) => item.dataset.label || item.value);
  label.textContent = checked.length === 0 ? "全部包体" : checked.length === 1 ? checked[0] : `已选 ${checked.length} 个包体`;
};

window.selectAllAnalyticsOverviewPackages = function () {
  document.querySelectorAll("[data-analytics-overview-package]").forEach((item) => { item.checked = true; });
  updateAnalyticsOverviewPackageLabel();
};

window.clearAnalyticsOverviewPackages = function () {
  document.querySelectorAll("[data-analytics-overview-package]").forEach((item) => { item.checked = false; });
  updateAnalyticsOverviewPackageLabel();
};

window.confirmAnalyticsOverviewPackages = function () {
  updateAnalyticsOverviewPackageLabel();
  toggleAnalyticsOverviewPackagePanel(false);
  applyAnalyticsOverviewFilters();
};

window.changeActivityRetentionGame = function (gameId) {
  navigate(`/ops/analytics/retention?game=${encodeURIComponent(gameId || "")}`);
};

window.applyAnalyticsOverviewFilters = function () {
  const time = document.getElementById("analytics-overview-time-label")?.textContent || "最近 7 天";
  const game = document.getElementById("analytics-overview-game-filter")?.value || getAnalyticsSelectedGame()?.id || "";
  const pkg = getAnalyticsOverviewSelectedPackageIds().join(",") || "全部包体";
  const region = document.getElementById("analytics-overview-region-filter")?.value || "全部区域";
  updateAnalyticsOverviewPackageLabel();
  toggleAnalyticsOverviewPackagePanel(false);
  const seed = [time, game, pkg, region].join("|").split("").reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  document.querySelectorAll("[data-analytics-metric]").forEach((el, idx) => {
    const base = Number(el.dataset.base || "0");
    const factor = 0.86 + ((seed + idx * 17) % 29) / 100;
    const next = el.dataset.percent === "true" ? Number((base * factor).toFixed(1)) : Math.max(0, Math.round(base * factor));
    el.textContent = el.dataset.percent === "true" ? `${next}%` : el.dataset.plain === "true" ? `${next} 条` : el.dataset.money === "true" ? UI.fmtMoney(next) : UI.fmtNum(next);
  });
  scheduleAnalyticsOverviewCharts(seed);
  UI.toast("数据已刷新", "success");
};

window.resetAnalyticsOverviewFilters = function () {
  const time = document.getElementById("analytics-overview-time-label");
  if (time) time.textContent = "最近 7 天";
  const game = document.getElementById("analytics-overview-game-filter");
  if (game) game.value = getAnalyticsSelectedGame()?.id || game.value;
  clearAnalyticsOverviewPackages();
  applyAnalyticsOverviewFilters();
};

function getAnalyticsSelectedGameId() {
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const activeGames = MOCK.GAMES.filter((g) => g.status === "active");
  const gameId = params.get("game") || activeGames[0]?.id || MOCK.GAMES[0]?.id || "";
  return (activeGames.find((g) => g.id === gameId) || activeGames[0] || MOCK.GAMES[0])?.id || "";
}

function getAnalyticsSelectedGame() {
  return MOCK.GAMES.find((g) => g.id === getAnalyticsSelectedGameId()) || MOCK.GAMES[0];
}

function getAnalyticsGamePackages(gameId = getAnalyticsSelectedGameId()) {
  return MOCK.PACKAGES.filter((p) => p.game_id === gameId);
}

function buildAnalyticsOverviewMetrics(packages = getAnalyticsGamePackages()) {
  const gameId = packages[0]?.game_id || getAnalyticsSelectedGameId();
  const rows = buildShareDataRows(gameId);
  const totals = rows.reduce((sum, row) => {
    sum.share += row.share || 0;
    sum.open += row.open || 0;
    sum.installStart += row.installStart || 0;
    sum.installSuccess += row.installSuccess || 0;
    sum.reflowStart += row.reflowStart || 0;
    sum.reflowSuccess += row.reflowSuccess || 0;
    return sum;
  }, { share: 0, open: 0, installStart: 0, installSuccess: 0, reflowStart: 0, reflowSuccess: 0 });
  return {
    ...totals,
    configCount: rows.length,
    openRate: Number(((totals.open / Math.max(1, totals.share)) * 100).toFixed(1)),
    installClickRate: Number(((totals.installStart / Math.max(1, totals.open)) * 100).toFixed(1)),
    installSuccessRate: Number(((totals.installSuccess / Math.max(1, totals.installStart)) * 100).toFixed(1)),
    reflowClickRate: Number(((totals.reflowStart / Math.max(1, totals.open)) * 100).toFixed(1)),
    reflowSuccessRate: Number(((totals.reflowSuccess / Math.max(1, totals.reflowStart)) * 100).toFixed(1)),
  };
}

function getAnalyticsPackageName(pkg) {
  const game = MOCK.GAMES.find((g) => g.id === pkg.game_id);
  return `${game?.name || "未知游戏"} / ${pkg.name}`;
}

function getAnalyticsRegions(packages = getAnalyticsGamePackages()) {
  return [...new Set(packages.map((p) => `${p.region} · ${p.region_name || p.region}`))];
}

function renderAnalyticsOverviewMetric(label, value, delta, sub, tone = "brand", type = "count") {
  const cls = tone === "ok" || tone === "green" ? "bg-ok-50 text-ok-700" : tone === "amber" ? "bg-warn-50 text-warn-700" : tone === "rose" ? "bg-danger-50 text-danger-700" : "bg-brand-50 text-brand-700";
  const deltaCls = tone === "ok" || tone === "green" ? "text-ok-700" : tone === "amber" ? "text-warn-700" : tone === "rose" ? "text-danger-700" : "text-brand-700";
  const numericValue = Number(String(value).replace(/[^0-9.]/g, "")) || 0;
  const isMoney = String(value).startsWith("$");
  const isPercent = String(value).includes("%");
  const isPlainCount = String(value).includes("条");
  const typeCls = type === "rate" ? "border-brand-100 bg-white" : "border-ink-100 bg-white";
  const logicCls = type === "rate" ? "text-brand-500" : "text-ink-400";
  return `
    <div class="rounded-lg border ${typeCls} p-2 min-w-0">
      <div class="text-[11px] text-ink-500 truncate" title="${label}">${label}</div>
      <div data-analytics-metric="true" data-base="${numericValue}" data-money="${isMoney}" data-percent="${isPercent}" data-plain="${isPlainCount}" class="num text-lg font-semibold text-ink-900 mt-1 truncate">${value}</div>
      <div class="mt-1 text-[10px] ${logicCls} truncate" title="${sub}">${sub}</div>
      <div class="mt-1 inline-flex items-center gap-1 rounded bg-ink-50 px-1.5 py-0.5 text-[10px] leading-none">
        <span class="text-ink-400">环比</span>
        <span class="font-semibold ${deltaCls}">${delta}</span>
      </div>
    </div>
  `;
}

function renderAnalyticsGameRow(game) {
  const clickRate = game.today.share ? ((game.today.click / game.today.share) * 100).toFixed(1) : "0.0";
  return `<tr class="border-b last:border-b-0 border-ink-100 row-hover"><td class="px-4 py-3 font-medium text-ink-900">${game.name}</td><td class="px-4 py-3 text-right num">${UI.fmtNum(game.today.share)}</td><td class="px-4 py-3 text-right num text-ok-700">${clickRate}%</td><td class="px-4 py-3 text-right num">${UI.fmtNum(game.today.install)}</td></tr>`;
}

function calculateAnalyticsRankRates(row) {
  return {
    ...row,
    openRate: Number(((row.open / Math.max(1, row.share)) * 100).toFixed(1)),
    installClickRate: Number(((row.installStart / Math.max(1, row.open)) * 100).toFixed(1)),
    installSuccessRate: Number(((row.installSuccess / Math.max(1, row.installStart)) * 100).toFixed(1)),
    reflowClickRate: Number(((row.reflowStart / Math.max(1, row.open)) * 100).toFixed(1)),
    reflowSuccessRate: Number(((row.reflowSuccess / Math.max(1, row.reflowStart)) * 100).toFixed(1)),
  };
}

function getAnalyticsPackageRankRows(packages = getAnalyticsGamePackages()) {
  return packages.map((pkg) => calculateAnalyticsRankRates({
    name: getAnalyticsPackageName(pkg),
    meta: pkg.region,
    share: getAnalyticsPackageMetricValue(pkg, "share"),
    open: getAnalyticsPackageMetricValue(pkg, "open"),
    installStart: getAnalyticsPackageMetricValue(pkg, "installStart"),
    installSuccess: getAnalyticsPackageMetricValue(pkg, "installSuccess"),
    reflowStart: getAnalyticsPackageMetricValue(pkg, "reflowStart"),
    reflowSuccess: getAnalyticsPackageMetricValue(pkg, "reflowSuccess"),
  })).sort((a, b) => b.share - a.share);
}

function buildAnalyticsRegionRows(packages = getAnalyticsGamePackages()) {
  const map = new Map();
  packages.forEach((pkg) => {
    const key = `${pkg.region} · ${pkg.region_name || pkg.region}`;
    const item = map.get(key) || { name: key, packageCount: 0, share: 0, open: 0, installStart: 0, installSuccess: 0, reflowStart: 0, reflowSuccess: 0 };
    item.packageCount += 1;
    item.meta = `${item.packageCount} 个包体`;
    item.share += getAnalyticsPackageMetricValue(pkg, "share");
    item.open += getAnalyticsPackageMetricValue(pkg, "open");
    item.installStart += getAnalyticsPackageMetricValue(pkg, "installStart");
    item.installSuccess += getAnalyticsPackageMetricValue(pkg, "installSuccess");
    item.reflowStart += getAnalyticsPackageMetricValue(pkg, "reflowStart");
    item.reflowSuccess += getAnalyticsPackageMetricValue(pkg, "reflowSuccess");
    map.set(key, item);
  });
  return Array.from(map.values()).map(calculateAnalyticsRankRates).sort((a, b) => b.share - a.share);
}

function buildAnalyticsPlatformRankRows(packages = getAnalyticsGamePackages()) {
  const map = new Map();
  packages.forEach((pkg) => {
    const key = pkg.platform || "未知平台";
    const item = map.get(key) || { name: key, packageCount: 0, share: 0, open: 0, installStart: 0, installSuccess: 0, reflowStart: 0, reflowSuccess: 0 };
    item.packageCount += 1;
    item.meta = `${item.packageCount} 个包体`;
    item.share += getAnalyticsPackageMetricValue(pkg, "share");
    item.open += getAnalyticsPackageMetricValue(pkg, "open");
    item.installStart += getAnalyticsPackageMetricValue(pkg, "installStart");
    item.installSuccess += getAnalyticsPackageMetricValue(pkg, "installSuccess");
    item.reflowStart += getAnalyticsPackageMetricValue(pkg, "reflowStart");
    item.reflowSuccess += getAnalyticsPackageMetricValue(pkg, "reflowSuccess");
    map.set(key, item);
  });
  return Array.from(map.values()).map(calculateAnalyticsRankRates).sort((a, b) => b.share - a.share);
}

function buildAnalyticsLanguageRankRows(packages = getAnalyticsGamePackages()) {
  const presets = [
    { name: "English", code: "en-US", weight: 36, variance: 4 },
    { name: "简体中文", code: "zh-CN", weight: 18, variance: 3 },
    { name: "繁體中文", code: "zh-TW", weight: 12, variance: 2 },
    { name: "日本語", code: "ja-JP", weight: 10, variance: 2 },
    { name: "한국어", code: "ko-KR", weight: 8, variance: 2 },
    { name: "ไทย", code: "th-TH", weight: 7, variance: 1 },
    { name: "Tiếng Việt", code: "vi-VN", weight: 6, variance: 1 },
    { name: "其它", code: "other", weight: 3, variance: 1 },
  ];
  const map = new Map(presets.map((item) => [item.name, { name: item.name, meta: item.code, share: 0, open: 0, installStart: 0, installSuccess: 0, reflowStart: 0, reflowSuccess: 0 }]));
  ["share", "open", "installStart", "installSuccess", "reflowStart", "reflowSuccess"].forEach((metric, idx) => {
    buildAnalyticsWeightedDistribution(metric, packages, presets, idx + 8).forEach((item) => {
      const row = map.get(item.name);
      if (row) row[metric] = item.value;
    });
  });
  return Array.from(map.values()).map(calculateAnalyticsRankRates).filter((row) => row.share > 0).sort((a, b) => b.share - a.share);
}

function renderAnalyticsRankTable(title, rows, firstLabel, metaLabel) {
  return `
    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <h3 class="text-sm font-semibold text-ink-900">${title}</h3>
        <span class="text-xs text-ink-400">按总分享数降序</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1560px] text-xs table-fixed">
          <thead class="bg-ink-50 text-xs text-ink-500 border-b border-ink-100">
            <tr>
              <th class="px-4 py-3 text-left font-medium w-[260px]">${firstLabel}</th>
              <th class="px-4 py-3 text-left font-medium w-[120px]">${metaLabel}</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">总分享数</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">总打开数</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">打开转化率</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">点击安装数</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">点击安装率</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">成功安装数</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">成功安装率</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">点击回流数</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">点击回流率</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">成功回流数</th>
              <th class="px-4 py-3 text-right font-medium w-[100px]">成功回流率</th>
            </tr>
          </thead>
          <tbody>${rows.map(renderAnalyticsRankRow).join("")}</tbody>
        </table>
      </div>
    </div>
  `;
}

function renderAnalyticsRankRow(row) {
  return `
    <tr class="border-b last:border-b-0 border-ink-100 row-hover">
      <td class="px-4 py-3 font-medium text-ink-900 truncate" title="${row.name}">${row.name}</td>
      <td class="px-4 py-3 text-ink-500 truncate" title="${row.meta || "—"}">${row.meta || "—"}</td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.share)}</td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.open)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.openRate}%</td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.installStart)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.installClickRate}%</td>
      <td class="px-4 py-3 text-right num text-ok-700">${UI.fmtNum(row.installSuccess)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.installSuccessRate}%</td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.reflowStart)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.reflowClickRate}%</td>
      <td class="px-4 py-3 text-right num text-ok-700">${UI.fmtNum(row.reflowSuccess)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.reflowSuccessRate}%</td>
    </tr>
  `;
}

function scheduleAnalyticsOverviewCharts(seed = 0) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      renderAnalyticsOverviewCharts(seed);
      setTimeout(() => resizeAnalyticsOverviewCharts(), 80);
    });
  });
}

function resizeAnalyticsOverviewCharts() {
  [
    "analytics-overview-trend",
    "analytics-overview-package-pie",
    "analytics-overview-region-pie",
    "analytics-overview-platform-pie",
    "analytics-overview-language-pie",
    "analytics-overview-device-model-pie",
    "analytics-overview-os-version-pie",
    "analytics-overview-memory-pie",
    "analytics-overview-share-frequency-pie",
    "analytics-overview-install-age-pie",
    "analytics-overview-active-level-pie",
  ].forEach((id) => {
    const el = document.getElementById(id);
    const chart = el && window.echarts ? echarts.getInstanceByDom(el) : null;
    if (chart) chart.resize();
  });
}

function renderAnalyticsOverviewCharts(seed = 0) {
  const trendEl = document.getElementById("analytics-overview-trend");
  if (trendEl && window.echarts) {
    const dates = getAnalyticsOverviewTrendDates();
    const trendSeries = buildAnalyticsOverviewRateTrend(dates.length, seed);
    const chart = echarts.getInstanceByDom(trendEl) || echarts.init(trendEl);
    chart.setOption({
      grid: { top: 44, right: 24, bottom: 36, left: 56 },
      tooltip: UI.chartTooltip({ valueFormatter: (value) => `${value}%` }),
      legend: { top: 12, left: 20, itemWidth: 10, itemHeight: 10, icon: "circle", textStyle: { color: "#64748B", fontSize: 12 } },
      xAxis: UI.chartXAxis(dates),
      yAxis: UI.chartYAxis({ axisLabel: { color: "#94A3B8", fontSize: 11, formatter: (v) => `${v}%` } }),
      series: [
        UI.chartLineSeries("打开转化率", trendSeries.openRate, { color: "#1E3A8A", area: true }),
        UI.chartLineSeries("点击安装率", trendSeries.installClickRate, { color: "#0F766E" }),
        UI.chartLineSeries("成功安装率", trendSeries.installSuccessRate, { color: "#16A34A" }),
        UI.chartLineSeries("点击回流率", trendSeries.reflowClickRate, { color: "#B45309" }),
        UI.chartLineSeries("成功回流率", trendSeries.reflowSuccessRate, { color: "#D97706" }),
      ],
    }, true);
    chart.resize();
  }
  const metric = document.getElementById("analytics-overview-pie-metric")?.value || "share";
  const packages = getAnalyticsGamePackages();
  renderAnalyticsDistributionPie("analytics-overview-package-pie", buildAnalyticsPackageDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-region-pie", buildAnalyticsRegionDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-platform-pie", buildAnalyticsPlatformDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-language-pie", buildAnalyticsLanguageDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-device-model-pie", buildAnalyticsDeviceModelDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-os-version-pie", buildAnalyticsOsVersionDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-memory-pie", buildAnalyticsMemoryDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-share-frequency-pie", buildAnalyticsShareFrequencyDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-install-age-pie", buildAnalyticsInstallAgeDistribution(metric, packages), metric);
  renderAnalyticsDistributionPie("analytics-overview-active-level-pie", buildAnalyticsActiveLevelDistribution(metric, packages), metric);
}

function getAnalyticsOverviewTrendDates() {
  const label = document.getElementById("analytics-overview-time-label")?.textContent?.trim() || "最近 7 天";
  const today = new Date(2026, 5, 6);
  const format = (date) => `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}`;
  const addDays = (date, days) => {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  };
  const range = (start, end) => {
    const days = [];
    for (let d = new Date(start); d <= end; d = addDays(d, 1)) days.push(format(d));
    return days;
  };
  if (label === "今天") return [format(today)];
  if (label === "昨天") return [format(addDays(today, -1))];
  if (label === "最近 30 天") return range(addDays(today, -29), today);
  const custom = label.match(/^(\d{4})-(\d{2})-(\d{2}) 至 (\d{4})-(\d{2})-(\d{2})$/);
  if (custom) {
    const start = new Date(Number(custom[1]), Number(custom[2]) - 1, Number(custom[3]));
    const end = new Date(Number(custom[4]), Number(custom[5]) - 1, Number(custom[6]));
    if (start <= end) return range(start, end);
  }
  return range(addDays(today, -6), today);
}

function buildAnalyticsOverviewRateTrend(length, seed = 0) {
  const make = (base, amp, offset) => Array.from({ length }, (_, idx) => {
    const wave = Math.sin((idx + offset) / 2.4) * amp;
    const drift = idx * 0.08;
    const jitter = ((seed + idx * 13 + offset * 7) % 9) / 10;
    return Number((base + wave + drift + jitter).toFixed(1));
  });
  return {
    openRate: make(29.4, 1.6, 1),
    installClickRate: make(42.8, 1.4, 3),
    installSuccessRate: make(66.2, 1.2, 5),
    reflowClickRate: make(16.4, 0.9, 7),
    reflowSuccessRate: make(58.6, 1.1, 9),
  };
}

function getAnalyticsPieMetricMeta(metric) {
  const map = {
    share: { label: "总分享数" },
    open: { label: "总打开数" },
    installStart: { label: "点击安装数" },
    installSuccess: { label: "成功安装数" },
    reflowStart: { label: "点击回流数" },
    reflowSuccess: { label: "成功回流数" },
  };
  return map[metric] || map.share;
}

function getAnalyticsPackageMetricValue(pkg, metric) {
  const share = (pkg.today_share || 0) * 7;
  const open = Math.round(share * 0.29);
  const installStart = Math.round(open * 0.43);
  const installSuccess = Math.round(installStart * 0.68);
  const reflowStart = Math.round(open * 0.16);
  const reflowSuccess = Math.round(reflowStart * 0.58);
  const map = { share, open, installStart, installSuccess, reflowStart, reflowSuccess };
  return map[metric] ?? share;
}

function buildAnalyticsGameDistribution(metric) {
  const game = getAnalyticsSelectedGame();
  const value = getAnalyticsGamePackages(game?.id).reduce((sum, pkg) => sum + getAnalyticsPackageMetricValue(pkg, metric), 0);
  return [{ name: game?.name || "当前游戏", value }].filter((item) => item.value > 0);
}

function buildAnalyticsPackageDistribution(metric, packages = getAnalyticsGamePackages()) {
  return packages.map((pkg) => ({ name: pkg.name, value: getAnalyticsPackageMetricValue(pkg, metric) })).filter((item) => item.value > 0);
}

function buildAnalyticsRegionDistribution(metric, packages = getAnalyticsGamePackages()) {
  const map = new Map();
  packages.forEach((pkg) => {
    const key = `${pkg.region} · ${pkg.region_name || pkg.region}`;
    map.set(key, (map.get(key) || 0) + getAnalyticsPackageMetricValue(pkg, metric));
  });
  return Array.from(map, ([name, value]) => ({ name, value })).filter((item) => item.value > 0);
}

function buildAnalyticsPlatformDistribution(metric, packages = getAnalyticsGamePackages()) {
  const map = new Map();
  packages.forEach((pkg) => {
    map.set(pkg.platform, (map.get(pkg.platform) || 0) + getAnalyticsPackageMetricValue(pkg, metric));
  });
  return Array.from(map, ([name, value]) => ({ name, value })).filter((item) => item.value > 0);
}

function buildAnalyticsWeightedDistribution(metric, packages, presets, seedOffset = 0) {
  const totals = presets.map((item) => ({ name: item.name, value: 0 }));
  packages.forEach((pkg, pkgIdx) => {
    const base = getAnalyticsPackageMetricValue(pkg, metric);
    const weights = presets.map((item, idx) => Math.max(1, item.weight + ((pkgIdx + idx + seedOffset) % 3 - 1) * (item.variance || 2)));
    const totalWeight = weights.reduce((sum, value) => sum + value, 0) || 1;
    weights.forEach((weight, idx) => {
      totals[idx].value += Math.round(base * weight / totalWeight);
    });
  });
  return totals.filter((item) => item.value > 0).sort((a, b) => b.value - a.value);
}

function buildAnalyticsLanguageDistribution(metric, packages = getAnalyticsGamePackages()) {
  return buildAnalyticsWeightedDistribution(metric, packages, [
    { name: "English", weight: 36, variance: 4 },
    { name: "简体中文", weight: 18, variance: 3 },
    { name: "繁體中文", weight: 12, variance: 2 },
    { name: "日本語", weight: 10, variance: 2 },
    { name: "한국어", weight: 8, variance: 2 },
    { name: "ไทย", weight: 7, variance: 1 },
    { name: "Tiếng Việt", weight: 6, variance: 1 },
    { name: "其它", weight: 3, variance: 1 },
  ], 1);
}

function buildAnalyticsDeviceModelDistribution(metric, packages = getAnalyticsGamePackages()) {
  const hasIos = packages.some((pkg) => String(pkg.platform || "").includes("iOS"));
  const hasAndroid = packages.some((pkg) => !String(pkg.platform || "").includes("iOS"));
  const presets = [
    ...(hasIos ? [
      { name: "iPhone 15 Pro", weight: 15, variance: 2 },
      { name: "iPhone 14", weight: 12, variance: 2 },
      { name: "iPhone 13", weight: 10, variance: 2 },
    ] : []),
    ...(hasAndroid ? [
      { name: "Samsung Galaxy S24", weight: 13, variance: 2 },
      { name: "Samsung Galaxy A54", weight: 10, variance: 2 },
      { name: "Xiaomi 14", weight: 9, variance: 2 },
      { name: "OPPO Reno11", weight: 8, variance: 1 },
      { name: "vivo V30", weight: 7, variance: 1 },
    ] : []),
    { name: "其它机型", weight: 16, variance: 2 },
  ];
  return buildAnalyticsWeightedDistribution(metric, packages, presets, 2);
}

function buildAnalyticsOsVersionDistribution(metric, packages = getAnalyticsGamePackages()) {
  const hasIos = packages.some((pkg) => String(pkg.platform || "").includes("iOS"));
  const hasAndroid = packages.some((pkg) => !String(pkg.platform || "").includes("iOS"));
  const presets = [
    ...(hasIos ? [
      { name: "iOS 17", weight: 22, variance: 3 },
      { name: "iOS 16", weight: 12, variance: 2 },
    ] : []),
    ...(hasAndroid ? [
      { name: "Android 14", weight: 24, variance: 3 },
      { name: "Android 13", weight: 18, variance: 3 },
      { name: "Android 12", weight: 10, variance: 2 },
    ] : []),
    { name: "其它版本", weight: 8, variance: 1 },
  ];
  return buildAnalyticsWeightedDistribution(metric, packages, presets, 3);
}

function buildAnalyticsMemoryDistribution(metric, packages = getAnalyticsGamePackages()) {
  return buildAnalyticsWeightedDistribution(metric, packages, [
    { name: "4GB 以下", weight: 8, variance: 1 },
    { name: "4GB", weight: 18, variance: 2 },
    { name: "6GB", weight: 26, variance: 3 },
    { name: "8GB", weight: 24, variance: 3 },
    { name: "12GB", weight: 16, variance: 2 },
    { name: "16GB 及以上", weight: 8, variance: 1 },
  ], 4);
}

function buildAnalyticsShareFrequencyDistribution(metric, packages = getAnalyticsGamePackages()) {
  return buildAnalyticsWeightedDistribution(metric, packages, [
    { name: "1 次", weight: 38, variance: 4 },
    { name: "2-3 次", weight: 30, variance: 3 },
    { name: "4-7 次", weight: 18, variance: 2 },
    { name: "8-15 次", weight: 9, variance: 1 },
    { name: "16 次及以上", weight: 5, variance: 1 },
  ], 5);
}

function buildAnalyticsInstallAgeDistribution(metric, packages = getAnalyticsGamePackages()) {
  return buildAnalyticsWeightedDistribution(metric, packages, [
    { name: "7天内安装用户", weight: 22, variance: 3 },
    { name: "8天-30天用户", weight: 27, variance: 3 },
    { name: "30天-90天用户", weight: 24, variance: 3 },
    { name: "90天-180天用户", weight: 16, variance: 2 },
    { name: "180天以上用户", weight: 11, variance: 2 },
  ], 6);
}

function buildAnalyticsActiveLevelDistribution(metric, packages = getAnalyticsGamePackages()) {
  return buildAnalyticsWeightedDistribution(metric, packages, [
    { name: "今日活跃", weight: 30, variance: 3 },
    { name: "近7天活跃", weight: 34, variance: 3 },
    { name: "近30天活跃", weight: 22, variance: 2 },
    { name: "沉默回流", weight: 14, variance: 2 },
  ], 7);
}

function renderAnalyticsDistributionPie(elementId, data, metric) {
  const el = document.getElementById(elementId);
  if (!el || !window.echarts) return;
  const meta = getAnalyticsPieMetricMeta(metric);
  const chart = echarts.getInstanceByDom(el) || echarts.init(el);
  chart.setOption({
    tooltip: { ...UI.chartTooltip(), trigger: "item", formatter: (p) => `${p.name}<br/>${meta.label} <b>${UI.fmtNum(p.value)}</b> · ${p.percent}%` },
    legend: { bottom: 0, type: "scroll", itemWidth: 8, itemHeight: 8, textStyle: { color: "#64748B", fontSize: 10 } },
    series: [{
      type: "pie",
      radius: ["42%", "68%"],
      center: ["50%", "43%"],
      itemStyle: { borderColor: "#fff", borderWidth: 2 },
      label: { color: "#64748B", fontSize: 11, formatter: "{b}\n{d}%" },
      data: data.map((item, idx) => ({ ...item, itemStyle: { color: UI.BUSINESS_COLORS[idx % UI.BUSINESS_COLORS.length] } })),
    }],
  }, true);
  chart.resize();
}

// ---------- 分享转化漏斗 ----------
function buildActivityRetentionRows(gameId = getAnalyticsSelectedGameId()) {
  return buildShareDataRows(gameId).map((row, idx) => {
    const seed = String(row.id || row.name || "").split("").reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
    const newUsers = Math.max(1, row.installSuccess || 0);
    const d1 = Math.max(18, Math.min(58, 46 - idx * 1.8 + (seed % 7) * 0.6));
    const d3 = Math.max(12, d1 * (0.76 - (idx % 3) * 0.025));
    const d7 = Math.max(8, d1 * (0.58 - (idx % 4) * 0.02));
    const d14 = Math.max(5, d1 * (0.43 - (idx % 3) * 0.018));
    const d30 = Math.max(3, d1 * (0.31 - (idx % 4) * 0.014));
    const count = (rate) => Math.round(newUsers * rate / 100);
    const rates = { d1: Number(d1.toFixed(1)), d3: Number(d3.toFixed(1)), d7: Number(d7.toFixed(1)), d14: Number(d14.toFixed(1)), d30: Number(d30.toFixed(1)) };
    return {
      ...row,
      newUsers,
      retention: {
        d1: { rate: rates.d1, count: count(rates.d1) },
        d3: { rate: rates.d3, count: count(rates.d3) },
        d7: { rate: rates.d7, count: count(rates.d7) },
        d14: { rate: rates.d14, count: count(rates.d14) },
        d30: { rate: rates.d30, count: count(rates.d30) },
      },
      retentionScore: Number((rates.d1 * 0.18 + rates.d3 * 0.18 + rates.d7 * 0.26 + rates.d14 * 0.18 + rates.d30 * 0.2).toFixed(1)),
    };
  }).sort((a, b) => b.retentionScore - a.retentionScore);
}

function renderRetentionCell(item, threshold) {
  const warn = item.rate < threshold;
  return `
    <td class="px-4 py-3 text-right ${warn ? "bg-amber-50" : ""}">
      <div class="num font-semibold ${warn ? "text-amber-700" : "text-ink-900"}">${item.rate}%</div>
      <div class="text-[11px] text-ink-400 mt-0.5">${UI.fmtNum(item.count)} 人</div>
    </td>
  `;
}

function renderActivityRetentionRow(row) {
  const r = row.retention;
  const scoreClass = row.retentionScore >= 28 ? "bg-ok-50 text-ok-700" : row.retentionScore >= 20 ? "bg-brand-50 text-brand-700" : "bg-amber-50 text-amber-700";
  return `
    <tr class="border-b last:border-b-0 border-ink-100 row-hover align-top">
      <td class="px-4 py-3 min-w-[240px]">
        <div class="font-medium text-ink-900">${row.name}</div>
        <div class="text-xs text-ink-500 mt-0.5 truncate">${row.title || "—"}</div>
        <div class="mt-1 text-[11px] text-ink-400">${row.packages} · ${row.languageCount || 0} 个语言版本</div>
      </td>
      <td class="px-4 py-3 text-right"><div class="num font-semibold text-ink-900">${UI.fmtNum(row.newUsers)}</div><div class="text-[11px] text-ink-400 mt-0.5">成功安装新用户</div></td>
      ${renderRetentionCell(r.d1, 30)}${renderRetentionCell(r.d3, 22)}${renderRetentionCell(r.d7, 15)}${renderRetentionCell(r.d14, 10)}${renderRetentionCell(r.d30, 7)}
      <td class="px-4 py-3 text-right"><span class="badge ${scoreClass}">${row.retentionScore}</span></td>
    </tr>
  `;
}

Pages.activityUserRetentionAnalysis = function () {
  const selectedGame = getAnalyticsSelectedGame();
  const selectedGameId = selectedGame?.id || MOCK.GAMES[0]?.id || "";
  const rows = buildActivityRetentionRows(selectedGameId);
  const best = rows[0];
  const avg = (key) => rows.length ? Number((rows.reduce((sum, row) => sum + row.retention[key].rate, 0) / rows.length).toFixed(1)) : 0;
  return `
    ${UI.pageHeader({
      title: "用户留存分析",
      desc: "按活动配置查看分享转化新用户的次留、3留、7留、14留、30留表现。",
      actions: `<button onclick="UI.toast('已导出留存表', 'success')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">导出留存</button>`,
    })}

    <div class="card p-4 mb-5">
      <div class="grid grid-cols-12 gap-3 items-end">
        <label class="col-span-4 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">游戏</span><select id="retention-game-filter" onchange="changeActivityRetentionGame(this.value)" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white">${MOCK.GAMES.filter((g) => g.status === "active").map((g) => `<option value="${g.id}" ${g.id === selectedGameId ? "selected" : ""}>${g.name}</option>`).join("")}</select></label>
        <label class="col-span-4 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">活动配置</span><input class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg" placeholder="搜索活动配置名称" /></label>
        <label class="col-span-4 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">排序</span><select class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white"><option>留存综合分从高到低</option><option>30留从高到低</option><option>转化新用户从高到低</option></select></label>
      </div>
    </div>

    <div class="grid grid-cols-5 gap-4 mb-5">
      ${renderAnalyticsOverviewMetric("转化新用户", UI.fmtNum(rows.reduce((sum, row) => sum + row.newUsers, 0)), "+6.8%", "成功安装口径", "brand")}
      ${renderAnalyticsOverviewMetric("平均次留", `${avg("d1")}%`, "+2.1%", "D1 retention", "ok")}
      ${renderAnalyticsOverviewMetric("平均7留", `${avg("d7")}%`, "+1.4%", "D7 retention", "blue")}
      ${renderAnalyticsOverviewMetric("平均30留", `${avg("d30")}%`, "-0.3%", "D30 retention", "amber")}
      ${renderAnalyticsOverviewMetric("最佳活动", best?.name || "—", "Top", "按留存综合分", "green")}
    </div>

    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div><h3 class="text-sm font-semibold text-ink-900">${selectedGame?.name || "当前游戏"} 用户留存分析表</h3><p class="text-xs text-ink-500 mt-0.5">按活动配置聚合其带来的分享转化新用户，展示次留、3留、7留、14留、30留。</p></div>
        <span class="text-xs text-ink-400">共 ${rows.length} 条</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1320px] text-sm">
          <thead class="bg-ink-50 text-xs text-ink-500 border-b border-ink-100"><tr><th class="px-4 py-3 text-left font-medium">活动配置</th><th class="px-4 py-3 text-right font-medium">分享转化新用户</th><th class="px-4 py-3 text-right font-medium">次留</th><th class="px-4 py-3 text-right font-medium">3留</th><th class="px-4 py-3 text-right font-medium">7留</th><th class="px-4 py-3 text-right font-medium">14留</th><th class="px-4 py-3 text-right font-medium">30留</th><th class="px-4 py-3 text-right font-medium">留存综合分</th></tr></thead>
          <tbody>${rows.map(renderActivityRetentionRow).join("")}</tbody>
        </table>
      </div>
    </div>
  `;
};

Pages.shareDataDetails = function () {
  window.__shareDataDetailContext = "";
  window.__shareDataDetailTimeRange = null;
  const selectedGame = getAnalyticsSelectedGame();
  const selectedGameId = selectedGame?.id || MOCK.GAMES[0]?.id || "";
  const rows = buildShareDataRows(selectedGameId);
  return `
    ${UI.pageHeader({
      title: "分享转化漏斗",
      desc: "按每一个分享配置查看全链路转化漏斗；每条配置的数据为该配置下多个语言版本的历史数据合计。",
      actions: `<button onclick="UI.toast('已导出漏斗表', 'success')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">导出漏斗</button>`,
    })}

    <div class="card p-4 mb-5"><div class="grid grid-cols-12 gap-3 items-end"><label class="col-span-4 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">游戏</span><select id="share-data-game-filter" onchange="changeShareDataDetailsGame(this.value)" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white">${MOCK.GAMES.filter((g) => g.status === "active").map((g) => `<option value="${g.id}" ${g.id === selectedGameId ? "selected" : ""}>${g.name}</option>`).join("")}</select></label><label class="col-span-4 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">分享配置</span><input class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg" placeholder="搜索配置名称" /></label><label class="col-span-4 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">状态</span><select class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white"><option>全部状态</option><option>已发布</option><option>草稿</option></select></label></div></div>

    <div class="card overflow-hidden"><div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between"><div><h3 class="text-sm font-semibold text-ink-900">${selectedGame?.name || "当前游戏"} 配置数据表</h3><p class="text-xs text-ink-500 mt-0.5">按分享配置聚合展示；每行总数据 = 中文源版本 + 已启用目标语种版本的数据合计。</p></div><span class="text-xs text-ink-400">共 ${rows.length} 条</span></div><div class="overflow-x-auto"><table class="w-full min-w-[1780px] text-sm"><thead class="bg-ink-50 text-xs text-ink-500 border-b border-ink-100"><tr><th class="px-4 py-3 text-left font-medium">分享配置</th><th class="px-4 py-3 text-right font-medium">总分享数</th><th class="px-4 py-3 text-right font-medium">总打开数</th><th class="px-4 py-3 text-right font-medium">打开转化率</th><th class="px-4 py-3 text-right font-medium">总点击安装数</th><th class="px-4 py-3 text-right font-medium">点击安装率</th><th class="px-4 py-3 text-right font-medium">总成功安装数</th><th class="px-4 py-3 text-right font-medium">成功安装率</th><th class="px-4 py-3 text-right font-medium">总点击回流数</th><th class="px-4 py-3 text-right font-medium">点击回流率</th><th class="px-4 py-3 text-right font-medium">总成功回流数</th><th class="px-4 py-3 text-right font-medium">成功回流率</th><th class="px-4 py-3 text-right font-medium">操作</th></tr></thead><tbody>${rows.map(renderShareDataRow).join("")}</tbody></table></div></div>
  `;
};

Pages.shareDataDetailPage = function (configId) {
  const selectedGame = getAnalyticsSelectedGame();
  const selectedGameId = selectedGame?.id || MOCK.GAMES[0]?.id || "";
  const detailContext = `${selectedGameId}:${configId}`;
  if (window.__shareDataDetailContext !== detailContext || !window.__shareDataDetailTimeRange) {
    window.__shareDataDetailContext = detailContext;
    window.__shareDataDetailTimeRange = getDefaultShareDataDetailTimeRange();
  }
  const timeRange = getShareDataDetailTimeRange();
  const rows = buildShareDataRows(selectedGameId, timeRange.days);
  const row = rows.find((item) => item.id === configId) || rows[0];
  if (!row) return UI.emptyState({ icon: "chart", title: "暂无分享数据", desc: "当前游戏下没有可查看的数据。" });
  PageHooks.mounted = () => requestAnimationFrame(() => renderShareDataDetailCharts(row));
  return `
    ${UI.pageHeader({
      title: "分享数据详情",
      desc: "以分享配置为统计单元，所有指标默认汇总该配置下中文源版本与各目标语种版本的数据。",
      actions: `<button onclick="navigate('/ops/analytics/share-details?game=${encodeURIComponent(selectedGameId)}')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回明细列表</button>`,
    })}

    <div class="card p-5 mb-5">
      <div class="flex items-start justify-between gap-4">
        <div class="min-w-0">
          <div class="text-lg font-semibold text-ink-900">${row.name}</div>
          <div class="text-xs text-ink-500 mt-1 truncate">${row.title || "—"}</div>
          <div class="mt-3 flex flex-wrap gap-2">
            <span class="badge bg-brand-50 text-brand-700">${selectedGame?.name || "当前游戏"}</span>
            <span class="badge bg-ok-50 text-ok-700">${row.statusText}</span>
            <code class="px-1.5 py-0.5 rounded bg-ink-50 border border-ink-100 text-[10px] font-mono text-ink-600">${row.id}</code>
          </div>

        </div>
        <div class="text-right flex-shrink-0">
          <div class="text-xs text-ink-500">打开转化率</div>
          <div class="num text-3xl font-semibold text-ok-700 mt-1">${row.clickRate}%</div>
        </div>
      </div>
    </div>

    <div class="card p-4 mb-5">
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div class="text-xs font-semibold text-ink-500">数据时间范围</div>
          <div id="share-detail-time-label" class="text-sm text-ink-900 mt-1">${timeRange.label}</div>
          <div class="text-xs text-ink-400 mt-1">当前所有指标均为该分享配置下多语言版本数据合计。</div>
        </div>
        <div class="flex items-center gap-2 flex-wrap">
          ${[7, 14, 30].map((days) => `<button type="button" onclick="setShareDataDetailTimePreset(${days})" class="px-3 py-1.5 text-xs rounded-lg border ${timeRange.days === days && !timeRange.custom ? "border-brand-300 bg-brand-50 text-brand-700" : "border-ink-100 hover:bg-ink-50 text-ink-600"}">最近 ${days} 天</button>`).join("")}
          <div class="relative">
            <button type="button" onclick="toggleShareDataDetailCustomTime()" class="px-3 py-1.5 text-xs rounded-lg border ${timeRange.custom ? "border-brand-300 bg-brand-50 text-brand-700" : "border-ink-100 hover:bg-ink-50 text-ink-600"}">自定义时间</button>
            <div id="share-detail-custom-time" class="hidden absolute right-0 top-full mt-2 w-[420px] z-20 rounded-xl border border-ink-200 bg-white shadow-pop p-3">
              <div class="grid grid-cols-2 gap-3">
                <label class="block"><span class="block text-xs font-medium text-ink-500 mb-1.5">开始时间</span><input id="share-detail-custom-start" type="date" value="${timeRange.start || "2026-06-01"}" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white" /></label>
                <label class="block"><span class="block text-xs font-medium text-ink-500 mb-1.5">结束时间</span><input id="share-detail-custom-end" type="date" value="${timeRange.end || "2026-06-07"}" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white" /></label>
              </div>
              <div class="mt-2 text-xs text-ink-400">自定义时间跨度不能超过 1 年。</div>
              <div class="mt-3 flex justify-end gap-2">
                <button type="button" onclick="toggleShareDataDetailCustomTime(false)" class="px-3 py-1.5 text-xs rounded-lg border border-ink-100 hover:bg-ink-50">取消</button>
                <button type="button" onclick="applyShareDataDetailCustomTime()" class="px-3 py-1.5 text-xs rounded-lg bg-brand-900 text-white hover:bg-brand-800">确定</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-6 gap-4 mb-5">
      ${renderAnalyticsOverviewMetric("分享数", UI.fmtNum(row.share), "+8.4%", "多语种合计", "brand")}
      ${renderAnalyticsOverviewMetric("打开数", UI.fmtNum(row.open), "+5.2%", "多语种合计", "ok")}
      ${renderAnalyticsOverviewMetric("点击安装数", UI.fmtNum(row.installStart), "+3.8%", "多语种合计", "blue")}
      ${renderAnalyticsOverviewMetric("成功安装数", UI.fmtNum(row.installSuccess), "+2.9%", "多语种合计", "green")}
      ${renderAnalyticsOverviewMetric("点击回流数", UI.fmtNum(row.reflowStart), "+2.1%", "多语种合计", "amber")}
      ${renderAnalyticsOverviewMetric("成功回流数", UI.fmtNum(row.reflowSuccess), "+1.6%", "多语种合计", "rose")}
    </div>

    <div class="space-y-5 mb-5">
      <div class="card overflow-hidden"><div class="px-5 py-4 border-b border-ink-100"><h3 class="text-sm font-semibold text-ink-900">核心链路趋势</h3></div><div id="share-detail-trend" class="h-[320px]"></div></div>
      <div class="card overflow-hidden"><div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between"><h3 class="text-sm font-semibold text-ink-900">链路漏斗</h3><span class="text-xs text-ink-400">节点数据 / 节点转化率</span></div>${renderShareDataDetailFunnel(row)}</div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100"><h3 class="text-sm font-semibold text-ink-900">包体明细</h3></div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1500px] table-fixed text-sm">${renderShareDataBreakdownColgroup()}${renderShareDataBreakdownHeader("包体")}<tbody>${row.packageRows.map(renderShareDataPackageRow).join("")}</tbody></table>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">场景明细</h3>
          <p class="text-xs text-ink-500 mt-0.5">按分享触发的业务场景拆分完整链路指标与转化率，表结构与其他明细列表保持一致。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">场景维度</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1500px] table-fixed text-sm">${renderShareDataBreakdownColgroup()}${renderShareDataBreakdownHeader("场景")}<tbody>${(row.sceneRows || []).map(renderShareDataSceneRow).join("")}</tbody></table>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">语言拆分数据明细</h3>
          <p class="text-xs text-ink-500 mt-0.5">按语言版本拆分展示完整链路指标与转化率；各语言行加总等于上方分享配置总数据。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">按语种拆分</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1500px] table-fixed text-sm">${renderShareDataBreakdownColgroup()}${renderShareDataBreakdownHeader("语言版本")}<tbody>${(row.languageRows || []).map(renderShareDataLanguageDetailRow).join("")}</tbody></table>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">访问区域（国家）明细</h3>
          <p class="text-xs text-ink-500 mt-0.5">按被分享者访问来源国家拆分完整链路指标与转化率。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">国家维度</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1500px] table-fixed text-sm">${renderShareDataBreakdownColgroup()}${renderShareDataBreakdownHeader("访问区域（国家）")}<tbody>${(row.countryRows || []).map(renderShareDataCountryRow).join("")}</tbody></table>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">手机型号明细</h3>
          <p class="text-xs text-ink-500 mt-0.5">仅列出访问量头部 20 个手机型号，剩余型号合并为“其它手机型号”。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">Top 20 + 其它</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1500px] table-fixed text-sm">${renderShareDataBreakdownColgroup()}${renderShareDataBreakdownHeader("手机型号")}<tbody>${(row.deviceModelRows || []).map(renderShareDataDeviceModelRow).join("")}</tbody></table>
      </div>
    </div>

    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100"><h3 class="text-sm font-semibold text-ink-900">渠道明细</h3></div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1500px] table-fixed text-sm">${renderShareDataBreakdownColgroup()}${renderShareDataBreakdownHeader("渠道")}<tbody>${row.channelRows.map(renderShareDataChannelRow).join("")}</tbody></table>
      </div>
    </div>
  `;
};

function getDefaultShareDataDetailTimeRange() {
  return { days: 7, label: "最近 7 天", custom: false, start: "2026-06-01", end: "2026-06-07" };
}

function getShareDataDetailTimeRange() {
  if (window.__shareDataDetailTimeRange) return window.__shareDataDetailTimeRange;
  return getDefaultShareDataDetailTimeRange();
}

function getShareDataDetailRangeDates() {
  const range = getShareDataDetailTimeRange();
  const end = range.custom && range.end ? parseDateOnly(range.end) : new Date(2026, 5, 7);
  const start = range.custom && range.start ? parseDateOnly(range.start) : addDateDays(end, -(range.days - 1));
  const days = Math.max(1, Math.min(365, daysBetween(start, end) + 1));
  return Array.from({ length: days }, (_item, idx) => formatMonthDay(addDateDays(start, idx)));
}

function parseDateOnly(value) {
  const [year, month, day] = String(value || "").split("-").map(Number);
  return new Date(year || 2026, (month || 1) - 1, day || 1);
}

function addDateDays(date, days) {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

function daysBetween(start, end) {
  return Math.floor((end - start) / 86400000);
}

function formatDateOnly(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

function formatMonthDay(date) {
  return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}`;
}

window.setShareDataDetailTimePreset = function (days) {
  const end = new Date(2026, 5, 7);
  const start = addDateDays(end, -(days - 1));
  window.__shareDataDetailTimeRange = { days, label: `最近 ${days} 天`, custom: false, start: formatDateOnly(start), end: formatDateOnly(end) };
  refreshShareDataDetailAfterTimeChange();
};

window.toggleShareDataDetailCustomTime = function (forceShow) {
  const panel = document.getElementById("share-detail-custom-time");
  if (!panel) return;
  const shouldShow = typeof forceShow === "boolean" ? forceShow : panel.classList.contains("hidden");
  panel.classList.toggle("hidden", !shouldShow);
};

window.applyShareDataDetailCustomTime = function () {
  const startValue = document.getElementById("share-detail-custom-start")?.value || "";
  const endValue = document.getElementById("share-detail-custom-end")?.value || "";
  if (!startValue || !endValue) { UI.toast("请选择完整的开始和结束时间", "warning"); return; }
  const start = parseDateOnly(startValue);
  const end = parseDateOnly(endValue);
  const days = daysBetween(start, end) + 1;
  if (days <= 0) { UI.toast("结束时间不能早于开始时间", "warning"); return; }
  if (days > 365) { UI.toast("自定义时间不能超过 1 年", "warning"); return; }
  window.__shareDataDetailTimeRange = { days, label: `${startValue} 至 ${endValue}`, custom: true, start: startValue, end: endValue };
  refreshShareDataDetailAfterTimeChange();
};

function getCurrentShareDataDetailConfigId() {
  const path = location.hash.replace(/^#/, "").split("?")[0];
  const match = path.match(/^\/ops\/analytics\/share-details\/([^/]+)$/);
  return match ? decodeURIComponent(match[1]) : "";
}

function getCurrentShareDataDetailRow() {
  const range = getShareDataDetailTimeRange();
  const rows = buildShareDataRows(getAnalyticsSelectedGameId(), range.days);
  const configId = getCurrentShareDataDetailConfigId();
  return rows.find((item) => item.id === configId) || rows[0];
}

function refreshShareDataDetailAfterTimeChange() {
  renderRoute();
  setTimeout(() => {
    const row = getCurrentShareDataDetailRow();
    if (row) renderShareDataDetailCharts(row);
  }, 0);
}

function createShareDataBreakdownRow(label, weight, totals, code = "", variance = {}) {
  const share = Math.round(totals.share * weight);
  const baseOpenRate = totals.open / Math.max(1, totals.share);
  const baseInstallClickRate = totals.installStart / Math.max(1, totals.open);
  const baseInstallSuccessRate = totals.installSuccess / Math.max(1, totals.installStart);
  const baseReflowClickRate = totals.reflowStart / Math.max(1, totals.open);
  const baseReflowSuccessRate = totals.reflowSuccess / Math.max(1, totals.reflowStart);
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const open = Math.round(share * clamp(baseOpenRate * (variance.open || 1), 0.18, 0.48));
  const installStart = Math.round(open * clamp(baseInstallClickRate * (variance.installClick || 1), 0.24, 0.62));
  const installSuccess = Math.round(installStart * clamp(baseInstallSuccessRate * (variance.installSuccess || 1), 0.46, 0.86));
  const reflowStart = Math.round(open * clamp(baseReflowClickRate * (variance.reflowClick || 1), 0.08, 0.34));
  const reflowSuccess = Math.round(reflowStart * clamp(baseReflowSuccessRate * (variance.reflowSuccess || 1), 0.42, 0.78));
  return { code, name: label, share, open, installStart, installSuccess, reflowStart, reflowSuccess };
}

const SHARE_DATA_LANGUAGE_PRESETS = [
  { code: "zh-CN", name: "简体中文", short: "中文", weight: 1.16 },
  { code: "en-US", name: "English", short: "EN", weight: 1.06 },
  { code: "zh-TW", name: "繁體中文", short: "繁中", weight: 0.88 },
  { code: "ja-JP", name: "日本語", short: "日语", weight: 0.78 },
  { code: "ko-KR", name: "한국어", short: "韩语", weight: 0.66 },
  { code: "th-TH", name: "ไทย", short: "泰语", weight: 0.58 },
  { code: "vi-VN", name: "Tiếng Việt", short: "越南语", weight: 0.52 },
];

function getShareDataLanguageVersions(configIndex) {
  const count = Math.min(SHARE_DATA_LANGUAGE_PRESETS.length, 4 + (configIndex % 3));
  return SHARE_DATA_LANGUAGE_PRESETS.slice(0, count);
}

function buildShareDataLanguageRows(totals, configIndex) {
  const versions = getShareDataLanguageVersions(configIndex);
  const weightTotal = versions.reduce((sum, item) => sum + item.weight, 0) || 1;
  return versions.map((locale, idx) => createShareDataBreakdownRow(`${locale.name} · ${locale.code}`, locale.weight / weightTotal, totals, locale.code, {
    open: 0.92 + idx * 0.035,
    installClick: 1.08 - idx * 0.035,
    installSuccess: 0.94 + (idx % 3) * 0.035,
    reflowClick: 0.88 + (idx % 4) * 0.05,
    reflowSuccess: 1.02 - (idx % 3) * 0.03,
  }));
}

function renderShareDataLanguageBadges(languages = []) {
  return languages.slice(0, 4).map((lang) => `<span class="px-1.5 py-0.5 rounded bg-brand-50 text-brand-700 text-[10px] font-medium">${lang.short}</span>`).join("") + (languages.length > 4 ? `<span class="px-1.5 py-0.5 rounded bg-ink-100 text-ink-500 text-[10px]">+${languages.length - 4}</span>` : "");
}

const SHARE_DATA_COUNTRY_PRESETS = [
  { code: "US", name: "美国 United States", weight: 1.28 },
  { code: "JP", name: "日本 Japan", weight: 1.06 },
  { code: "TW", name: "中国台湾 Taiwan", weight: 0.92 },
  { code: "KR", name: "韩国 South Korea", weight: 0.84 },
  { code: "TH", name: "泰国 Thailand", weight: 0.78 },
  { code: "VN", name: "越南 Vietnam", weight: 0.72 },
  { code: "SG", name: "新加坡 Singapore", weight: 0.58 },
  { code: "MY", name: "马来西亚 Malaysia", weight: 0.52 },
  { code: "ID", name: "印度尼西亚 Indonesia", weight: 0.48 },
  { code: "CA", name: "加拿大 Canada", weight: 0.42 },
  { code: "GB", name: "英国 United Kingdom", weight: 0.38 },
  { code: "AU", name: "澳大利亚 Australia", weight: 0.34 },
];

const SHARE_DATA_DEVICE_MODEL_PRESETS = [
  { code: "iphone_15_pro_max", name: "iPhone 15 Pro Max", weight: 1.32 },
  { code: "iphone_15", name: "iPhone 15", weight: 1.18 },
  { code: "iphone_14_pro", name: "iPhone 14 Pro", weight: 1.08 },
  { code: "iphone_14", name: "iPhone 14", weight: 1.0 },
  { code: "iphone_13", name: "iPhone 13", weight: 0.92 },
  { code: "galaxy_s24_ultra", name: "Samsung Galaxy S24 Ultra", weight: 0.88 },
  { code: "galaxy_s23", name: "Samsung Galaxy S23", weight: 0.82 },
  { code: "galaxy_a54", name: "Samsung Galaxy A54", weight: 0.76 },
  { code: "pixel_8_pro", name: "Google Pixel 8 Pro", weight: 0.7 },
  { code: "pixel_7", name: "Google Pixel 7", weight: 0.64 },
  { code: "xiaomi_14", name: "Xiaomi 14", weight: 0.6 },
  { code: "redmi_note_13", name: "Redmi Note 13", weight: 0.56 },
  { code: "oppo_find_x7", name: "OPPO Find X7", weight: 0.52 },
  { code: "oppo_reno_11", name: "OPPO Reno 11", weight: 0.48 },
  { code: "vivo_x100", name: "vivo X100", weight: 0.45 },
  { code: "vivo_v30", name: "vivo V30", weight: 0.42 },
  { code: "oneplus_12", name: "OnePlus 12", weight: 0.38 },
  { code: "honor_magic6", name: "HONOR Magic6", weight: 0.35 },
  { code: "huawei_pura70", name: "HUAWEI Pura 70", weight: 0.32 },
  { code: "realme_gt5", name: "realme GT5", weight: 0.3 },
  { code: "motorola_edge_40", name: "Motorola Edge 40", weight: 0.26 },
  { code: "sony_xperia_1v", name: "Sony Xperia 1 V", weight: 0.22 },
  { code: "asus_rog_8", name: "ROG Phone 8", weight: 0.2 },
  { code: "tecno_cam_20", name: "TECNO Camon 20", weight: 0.18 },
];

const SHARE_DATA_SCENE_PRESETS = [
  { code: "friend_invite", name: "好友邀请", weight: 1.24 },
  { code: "guild_recruit", name: "公会 / 联盟招募", weight: 1.06 },
  { code: "event_campaign", name: "限时活动分享", weight: 0.94 },
  { code: "reward_claim", name: "礼包 / 奖励领取", weight: 0.86 },
  { code: "achievement_showcase", name: "成就 / 战绩炫耀", weight: 0.74 },
  { code: "returning_recall", name: "老用户回流召回", weight: 0.66 },
  { code: "payment_benefit", name: "首充 / 付费福利", weight: 0.52 },
  { code: "ugc_share", name: "UGC 内容分享", weight: 0.42 },
];

function buildShareDataWeightedBreakdownRows(items, totals, varianceSeed = 0) {
  const totalWeight = items.reduce((sum, item) => sum + item.weight, 0) || 1;
  return items.map((item, idx) => {
    const variance = {
      open: 0.9 + ((idx + varianceSeed) % 6) * 0.035,
      installClick: 1.08 - ((idx + varianceSeed) % 5) * 0.035,
      installSuccess: 0.92 + ((idx + varianceSeed) % 4) * 0.04,
      reflowClick: 0.88 + ((idx + varianceSeed) % 5) * 0.045,
      reflowSuccess: 1.04 - ((idx + varianceSeed) % 4) * 0.03,
    };
    if ([2, 11].includes(idx)) variance.open = 0.62;
    if ([5, 14].includes(idx)) variance.installClick = 0.62;
    if ([8, 17].includes(idx)) variance.installSuccess = 0.68;
    if ([4, 16].includes(idx)) variance.reflowClick = 0.55;
    if ([7, 20].includes(idx)) variance.reflowSuccess = 0.62;
    return createShareDataBreakdownRow(item.name, item.weight / totalWeight, totals, item.code, variance);
  });
}

function buildShareDataCountryRows(totals, configIndex) {
  return buildShareDataWeightedBreakdownRows(SHARE_DATA_COUNTRY_PRESETS, totals, configIndex);
}

function buildShareDataDeviceModelRows(totals, configIndex) {
  const topModels = SHARE_DATA_DEVICE_MODEL_PRESETS.slice(0, 20);
  const otherModels = SHARE_DATA_DEVICE_MODEL_PRESETS.slice(20);
  const otherWeight = otherModels.reduce((sum, item) => sum + item.weight, 0);
  return buildShareDataWeightedBreakdownRows([...topModels, { code: "other", name: "其它手机型号", weight: otherWeight }], totals, configIndex + 3);
}

function buildShareDataSceneRows(totals, configIndex) {
  return buildShareDataWeightedBreakdownRows(SHARE_DATA_SCENE_PRESETS, totals, configIndex + 5);
}

function buildShareDataRows(gameId = getAnalyticsSelectedGameId(), days = 7) {
  return (MOCK.SHARE_CONFIGS || []).filter((cfg) => cfg.scope === "package_set").map((cfg, idx) => {
    const pkgs = (cfg.package_ids || []).map((id) => MOCK.PACKAGES.find((p) => p.id === id)).filter(Boolean).filter((pkg) => pkg.game_id === gameId);
    if (!pkgs.length) return null;
    const dayFactor = Math.max(1, Math.min(365, Number(days) || 7)) / 7;
    const share = Math.max(1200, Math.round((52000 - idx * 1800) * (pkgs.length / Math.max(1, (cfg.package_ids || []).length)) * dayFactor));
    const open = Math.round(share * (0.32 - (idx % 4) * 0.018));
    const installStart = Math.round(open * (0.44 - (idx % 3) * 0.025));
    const installSuccess = Math.round(installStart * (0.72 - (idx % 4) * 0.035));
    const reflowStart = Math.round(open * (0.18 + (idx % 3) * 0.018));
    const reflowSuccess = Math.round(reflowStart * (0.64 - (idx % 3) * 0.028));
    const clickRate = Number(((open / Math.max(1, share)) * 100).toFixed(1));
    const installRate = Number(((installSuccess / Math.max(1, installStart)) * 100).toFixed(1));
    const registerRate = Number(((reflowSuccess / Math.max(1, reflowStart)) * 100).toFixed(1));
    const purchaseRate = Number((3.4 - (idx % 4) * 0.28).toFixed(1));
    const packageBases = pkgs.map((pkg, pidx) => (pkg.today_share || 1000) * (1 + pidx * 0.04));
    const packageBaseTotal = packageBases.reduce((sum, value) => sum + value, 0) || 1;
    const packageRows = pkgs.map((pkg, pidx) => {
      const platformFactor = /iOS/i.test(pkg.platform) ? 1.08 : (/Google Play/i.test(pkg.platform) ? 0.96 : 0.9);
      const regionSeed = String(pkg.region || "").split("").reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
      const regionFactor = 0.9 + (regionSeed % 17) / 100;
      const variance = {
        open: platformFactor * (0.92 + (pidx % 4) * 0.055),
        installClick: regionFactor * (0.88 + (pidx % 3) * 0.08),
        installSuccess: platformFactor * (0.9 + ((pidx + idx) % 4) * 0.045),
        reflowClick: (1.04 / platformFactor) * (0.9 + (regionSeed % 5) * 0.04),
        reflowSuccess: regionFactor * (0.92 + ((pidx + 2) % 4) * 0.035),
      };
      if (pidx === 1) variance.installClick = 0.62;
      if (pidx === 2) variance.open = 0.62;
      if (pidx === 3) variance.reflowSuccess = 0.62;
      return createShareDataBreakdownRow(pkg.name, packageBases[pidx] / packageBaseTotal, { share, open, installStart, installSuccess, reflowStart, reflowSuccess }, pkg.id, variance);
    });
    const channelCodes = (cfg.channels || []).slice(0, 5);
    const channelBaseTotal = channelCodes.reduce((sum, _code, cidx) => sum + (1 + cidx * 0.08), 0) || 1;
    const channelRows = channelCodes.map((code, cidx) => {
      const channel = MOCK.CHANNELS.find((c) => c.code === code);
      const variance = {
        open: 0.88 + cidx * 0.055,
        installClick: 1.1 - cidx * 0.045,
        installSuccess: 0.92 + (cidx % 3) * 0.04,
        reflowClick: 0.9 + (cidx % 4) * 0.055,
        reflowSuccess: 1.04 - (cidx % 3) * 0.035,
      };
      if (cidx === 2) variance.open = 0.62;
      if (cidx === 3) variance.reflowClick = 0.55;
      return createShareDataBreakdownRow(channel ? `${channel.icon} ${channel.name}` : code, (1 + cidx * 0.08) / channelBaseTotal, { share, open, installStart, installSuccess, reflowStart, reflowSuccess }, code, variance);
    });
    const languageVersions = getShareDataLanguageVersions(idx);
    const totals = { share, open, installStart, installSuccess, reflowStart, reflowSuccess };
    const languageRows = buildShareDataLanguageRows(totals, idx);
    const countryRows = buildShareDataCountryRows(totals, idx);
    const deviceModelRows = buildShareDataDeviceModelRows(totals, idx);
    const sceneRows = buildShareDataSceneRows(totals, idx);
    return {
      id: cfg.id,
      name: cfg.name,
      title: cfg.title,
      scope: cfg.mode === "expert" ? "高级活动" : "标准活动",
      packageCount: pkgs.length,
      packages: pkgs.length ? `${pkgs.length} 个包体` : "未关联包体",
      packageNames: pkgs.slice(0, 2).map((pkg) => pkg.name).join("、") + (pkgs.length > 2 ? " 等" : ""),
      statusText: cfg.status === "released" ? "已发布" : "草稿",
      languageVersions,
      languageCount: languageVersions.length,
      languageRows,
      countryRows,
      deviceModelRows,
      sceneRows,
      share,
      open,
      installStart,
      installSuccess,
      reflowStart,
      reflowSuccess,
      clickRate,
      installRate,
      registerRate,
      purchaseRate,
      packageRows,
      channelRows,
    };
  }).filter(Boolean);
}

function renderShareDataRow(row) {
  const openRate = Number(((row.open / Math.max(1, row.share)) * 100).toFixed(1));
  const installClickRate = Number(((row.installStart / Math.max(1, row.open)) * 100).toFixed(1));
  const installSuccessRate = Number(((row.installSuccess / Math.max(1, row.installStart)) * 100).toFixed(1));
  const reflowClickRate = Number(((row.reflowStart / Math.max(1, row.open)) * 100).toFixed(1));
  const reflowSuccessRate = Number(((row.reflowSuccess / Math.max(1, row.reflowStart)) * 100).toFixed(1));
  const rateClass = (rate, threshold) => rate < threshold ? "text-danger-600 font-semibold bg-danger-50" : "text-brand-700 font-semibold";
  const rateTitle = (rate, threshold) => rate < threshold ? " title=\"该转化率明显低于整体合理区间，请重点排查\"" : "";
  return `
    <tr class="border-b last:border-b-0 border-ink-100 row-hover">
      <td class="px-4 py-3 min-w-[220px]">
        <div class="font-medium text-ink-900">${row.name}</div>
        <div class="text-xs text-ink-500 mt-0.5 truncate">${row.title || "—"}</div>
        <div class="mt-1 text-[11px] text-ink-400">数据口径：多语种版本合计</div>
      </td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.share)}</td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.open)}</td>
      <td${rateTitle(openRate, 24)} class="px-4 py-3 text-right num ${rateClass(openRate, 24)}">${openRate}%</td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.installStart)}</td>
      <td${rateTitle(installClickRate, 32)} class="px-4 py-3 text-right num ${rateClass(installClickRate, 32)}">${installClickRate}%</td>
      <td class="px-4 py-3 text-right num text-ok-700">${UI.fmtNum(row.installSuccess)}</td>
      <td${rateTitle(installSuccessRate, 55)} class="px-4 py-3 text-right num ${rateClass(installSuccessRate, 55)}">${installSuccessRate}%</td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.reflowStart)}</td>
      <td${rateTitle(reflowClickRate, 11)} class="px-4 py-3 text-right num ${rateClass(reflowClickRate, 11)}">${reflowClickRate}%</td>
      <td class="px-4 py-3 text-right num text-ok-700">${UI.fmtNum(row.reflowSuccess)}</td>
      <td${rateTitle(reflowSuccessRate, 45)} class="px-4 py-3 text-right num ${rateClass(reflowSuccessRate, 45)}">${reflowSuccessRate}%</td>
      <td class="px-4 py-3 text-right"><button onclick="navigate('/ops/analytics/share-details/${row.id}?game=${encodeURIComponent(getAnalyticsSelectedGameId())}')" class="text-xs text-brand-600 hover:underline">数据详情</button></td>
    </tr>
  `;
}

function renderShareDataLanguageSummaryRow(row, totalShare = row.share) {
  const shareRatio = `${((row.share / Math.max(1, totalShare)) * 100).toFixed(1)}%`;
  return `
    <tr class="border-b last:border-b-0 border-ink-100 row-hover">
      <td class="px-4 py-3"><div class="font-medium text-ink-900">${row.name}</div><div class="text-[11px] text-ink-400 mt-0.5">语言版本配置</div></td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.share)}</td>
      <td class="px-4 py-3 text-right text-ink-500">${shareRatio}</td>
      <td class="px-4 py-3 text-right num">${UI.fmtNum(row.open)}</td>
      <td class="px-4 py-3 text-right num text-ok-700">${UI.fmtNum(row.installSuccess)}</td>
      <td class="px-4 py-3 text-right num text-ok-700">${UI.fmtNum(row.reflowSuccess)}</td>
    </tr>
  `;
}

function getShareDataFunnelStages(row) {
  const nextAction = row.installStart + row.reflowStart;
  const totalSuccess = row.installSuccess + row.reflowSuccess;
  return {
    main: [
      { name: "分享数", value: row.share, color: "#1E3A8A", rateLabel: "", rate: null, desc: "发起分享" },
      { name: "打开数", value: row.open, color: "#2563EB", rateLabel: "打开转化率", rate: Number(((row.open / Math.max(1, row.share)) * 100).toFixed(1)), desc: "分享被打开" },
      { name: "Action", value: nextAction, color: "#60A5FA", rateLabel: "Action率", rate: Number(((nextAction / Math.max(1, row.open)) * 100).toFixed(1)), desc: "点击安装 + 点击回流" },
      { name: "总成功数", value: totalSuccess, color: "#0F766E", rateLabel: "总成功转化率", rate: Number(((totalSuccess / Math.max(1, nextAction)) * 100).toFixed(1)), desc: "成功安装 + 成功回流" },
    ],
    install: [
      { name: "点击安装数", value: row.installStart, color: "#60A5FA", rateLabel: "点击安装率", rate: Number(((row.installStart / Math.max(1, row.open)) * 100).toFixed(1)) },
      { name: "成功安装数", value: row.installSuccess, color: "#0F766E", rateLabel: "成功安装率", rate: Number(((row.installSuccess / Math.max(1, row.installStart)) * 100).toFixed(1)) },
    ],
    reflow: [
      { name: "点击回流数", value: row.reflowStart, color: "#B45309", rateLabel: "点击回流率", rate: Number(((row.reflowStart / Math.max(1, row.open)) * 100).toFixed(1)) },
      { name: "成功回流数", value: row.reflowSuccess, color: "#D97706", rateLabel: "成功回流率", rate: Number(((row.reflowSuccess / Math.max(1, row.reflowStart)) * 100).toFixed(1)) },
    ],
  };
}

function renderShareDataFunnelNode(stage, max, tone = "normal") {
  const width = Math.max(18, Math.round((stage.value / Math.max(1, max)) * 100));
  const compact = tone === "branch";
  return `
    <div class="rounded-xl border border-ink-100 bg-white p-3 shadow-soft">
      <div class="flex items-start justify-between gap-3">
        <div class="min-w-0">
          <div class="text-xs font-semibold text-ink-700 truncate">${stage.name}</div>
          <div class="num ${compact ? "text-base" : "text-lg"} font-semibold text-ink-900 mt-0.5">${UI.fmtNum(stage.value)}</div>
          ${stage.desc ? `<div class="text-[11px] text-ink-400 mt-0.5">${stage.desc}</div>` : ""}
        </div>
        <div class="text-right flex-shrink-0">
          ${stage.rateLabel ? `<div class="text-[11px] text-ink-400">${stage.rateLabel}</div><div class="num text-sm font-semibold text-brand-700">${stage.rate}%</div>` : ""}
        </div>
      </div>
      <div class="mt-3 h-2 rounded-full bg-ink-100 overflow-hidden">
        <div class="h-full rounded-full" style="width:${width}%; background:${stage.color}"></div>
      </div>
    </div>
  `;
}

function renderShareDataFunnelSvgLayer(stage, y, height, topWidth, bottomWidth, color, options = {}) {
  const cx = options.cx || 490;
  const topLeft = cx - topWidth / 2;
  const topRight = cx + topWidth / 2;
  const bottomLeft = cx - bottomWidth / 2;
  const bottomRight = cx + bottomWidth / 2;
  const midY = y + height / 2;
  const rateText = stage.rateLabel ? `${stage.rateLabel} ${stage.rate}%` : "";
  const side = options.side || "left";
  const labelX = side === "left" ? topLeft - 24 : topRight + 24;
  const anchor = side === "left" ? "end" : "start";
  const lineX = side === "left" ? topLeft - 8 : topRight + 8;
  const lineEndX = side === "left" ? labelX + 8 : labelX - 8;
  return `
    <polygon points="${topLeft},${y} ${topRight},${y} ${bottomRight},${y + height} ${bottomLeft},${y + height}" fill="${color}" stroke="#FFFFFF" stroke-width="3" />
    <path d="M${lineX} ${midY} L${lineEndX} ${midY}" stroke="${color}" stroke-width="1.5" stroke-opacity="0.5" />
    <text x="${labelX}" y="${midY - 16}" text-anchor="${anchor}" fill="#334155" font-size="13" font-weight="700">${stage.name}</text>
    <text x="${labelX}" y="${midY + 5}" text-anchor="${anchor}" fill="#0F172A" font-size="20" font-weight="700" class="num">${UI.fmtNum(stage.value)}</text>
    ${rateText ? `<text x="${labelX}" y="${midY + 24}" text-anchor="${anchor}" fill="#1D4ED8" font-size="12" font-weight="700">${rateText}</text>` : ""}
    ${options.desc ? `<text x="${labelX}" y="${midY + 41}" text-anchor="${anchor}" fill="#64748B" font-size="11">${options.desc}</text>` : ""}
  `;
}

function getShareDataSdkPlatformRows(row) {
  const platforms = [
    { key: "ios", label: "iOS", color: "#F59E0B", weight: 0.36 },
    { key: "android", label: "Android", color: "#22C55E", weight: 0.34 },
    { key: "steam", label: "Steam", color: "#2563EB", weight: 0.18 },
    { key: "other", label: "其它平台", color: "#64748B", weight: 0.12 },
  ];
  const rows = [
    { label: "分享数", total: row.share },
    { label: "打开数", total: row.open },
    { label: "点击安装数", total: row.installStart },
    { label: "成功安装数", total: row.installSuccess },
    { label: "点击回流数", total: row.reflowStart },
    { label: "成功回流数", total: row.reflowSuccess },
  ];
  return rows.map((item) => ({
    ...item,
    platforms: platforms.map((platform) => ({ ...platform, value: Math.round(item.total * platform.weight) })),
  }));
}

function renderShareDataSdkPlatformSummary(row) {
  const rows = getShareDataSdkPlatformRows(row);
  const platforms = rows[0]?.platforms || [];
  return `
    <g>
      <rect x="24" y="34" width="410" height="430" rx="22" fill="#FFFFFF" stroke="#E2E8F0" />
      <rect x="24" y="34" width="410" height="74" rx="22" fill="#F8FAFC" />
      <rect x="24" y="88" width="410" height="20" fill="#F8FAFC" />
      <rect x="48" y="58" width="4" height="28" rx="2" fill="#2563EB" />
      <text x="64" y="66" fill="#0F172A" font-size="15" font-weight="800">SDK 平台拆解</text>
      <text x="64" y="88" fill="#64748B" font-size="11">当前配置 · 当前时间范围</text>
      ${platforms.map((platform, idx) => {
        const x = 154 + idx * 64;
        return `
          <g>
            <circle cx="${x}" cy="126" r="4" fill="${platform.color}" />
            <text x="${x + 8}" y="130" fill="#475569" font-size="10" font-weight="800">${platform.label}</text>
          </g>
        `;
      }).join("")}
      ${rows.map((item, idx) => {
        const y = 154 + idx * 48;
        const bg = idx % 2 === 0 ? "#F8FAFC" : "#FFFFFF";
        return `
          <g>
            <rect x="40" y="${y - 24}" width="378" height="40" rx="10" fill="${bg}" />
            <text x="54" y="${y - 5}" fill="#64748B" font-size="11" font-weight="800">${item.label}</text>
            <text x="54" y="${y + 12}" fill="#0F172A" font-size="15" font-weight="800" class="num">${UI.fmtNum(item.total)}</text>
            ${item.platforms.map((platform, pidx) => {
              const x = 154 + pidx * 64;
              return `<text x="${x}" y="${y + 7}" fill="#0F172A" font-size="12" font-weight="800" class="num">${UI.fmtNum(platform.value)}</text>`;
            }).join("")}
          </g>
        `;
      }).join("")}
    </g>
  `;
}

function renderShareDataFunnelSvgChip(stage, x, y, width, color) {
  return `
    <g>
      <rect x="${x}" y="${y}" width="${width}" height="62" rx="14" fill="#FFFFFF" fill-opacity="0.98" stroke="${color}" stroke-opacity="0.35" stroke-width="1.4" />
      <rect x="${x + 8}" y="${y + 8}" width="3" height="46" rx="1.5" fill="${color}" />
      <text x="${x + 20}" y="${y + 21}" fill="#334155" font-size="12" font-weight="800">${stage.name}</text>
      <text x="${x + 20}" y="${y + 42}" fill="#0F172A" font-size="16" font-weight="800" class="num">${UI.fmtNum(stage.value)}</text>
      <text x="${x + width - 12}" y="${y + 22}" text-anchor="end" fill="${color}" font-size="12" font-weight="800">${stage.rateLabel}</text>
      <text x="${x + width - 12}" y="${y + 45}" text-anchor="end" fill="${color}" font-size="20" font-weight="900" class="num">${stage.rate}%</text>
    </g>
  `;
}

function renderShareDataDetailFunnel(row) {
  const groups = getShareDataFunnelStages(row);
  const platformRows = getShareDataSdkPlatformRows(row);
  const getPlatformValue = (rows, keys) => rows.reduce((sum, item) => sum + keys.reduce((subtotal, key) => subtotal + (item.platforms.find((platform) => platform.key === key)?.value || 0), 0), 0);
  const makeSdkStageRow = (label, rows, color = "#CBD5E1") => ({
    label,
    color,
    total: rows.reduce((sum, item) => sum + item.total, 0),
    ios: getPlatformValue(rows, ["ios"]),
    android: getPlatformValue(rows, ["android"]),
    other: getPlatformValue(rows, ["steam", "other"]),
  });
  const sdkFunnelRows = [
    { main: makeSdkStageRow("分享数", [platformRows[0]], "#1E3A8A"), branches: [] },
    { main: makeSdkStageRow("打开数", [platformRows[1]], "#2563EB"), branches: [] },
    {
      main: makeSdkStageRow("Action", [platformRows[2], platformRows[4]], "#38BDF8"),
      branches: [makeSdkStageRow("点击安装数", [platformRows[2]], "#2563EB"), makeSdkStageRow("点击回流数", [platformRows[4]], "#B45309")],
    },
    {
      main: makeSdkStageRow("总成功数", [platformRows[3], platformRows[5]], "#0F766E"),
      branches: [makeSdkStageRow("成功安装数", [platformRows[3]], "#0F766E"), makeSdkStageRow("成功回流数", [platformRows[5]], "#D97706")],
    },
  ];
  const branchStyle = {
    blue: { color: "#2563EB", bg: "#EFF6FF", border: "#BFDBFE" },
    amber: { color: "#B45309", bg: "#FFFBEB", border: "#FDE68A" },
    green: { color: "#0F766E", bg: "#ECFDF5", border: "#A7F3D0" },
    orange: { color: "#D97706", bg: "#FFF7ED", border: "#FED7AA" },
  };
  const getRateFormula = (stage) => {
    const action = row.installStart + row.reflowStart;
    const success = row.installSuccess + row.reflowSuccess;
    const formulas = {
      "打开数": { logic: "打开转化率 = 打开数 ÷ 分享数", formula: `${UI.fmtNum(row.open)} ÷ ${UI.fmtNum(row.share)} = ${stage.rate}%` },
      "Action": { logic: "Action率 = Action ÷ 打开数", formula: `(${UI.fmtNum(row.installStart)} + ${UI.fmtNum(row.reflowStart)}) ÷ ${UI.fmtNum(row.open)} = ${stage.rate}%` },
      "总成功数": { logic: "总成功转化率 = 总成功数 ÷ Action", formula: `(${UI.fmtNum(row.installSuccess)} + ${UI.fmtNum(row.reflowSuccess)}) ÷ ${UI.fmtNum(action)} = ${stage.rate}%` },
      "点击安装数": { logic: "点击安装率 = 点击安装数 ÷ 打开数", formula: `${UI.fmtNum(row.installStart)} ÷ ${UI.fmtNum(row.open)} = ${stage.rate}%` },
      "点击回流数": { logic: "点击回流率 = 点击回流数 ÷ 打开数", formula: `${UI.fmtNum(row.reflowStart)} ÷ ${UI.fmtNum(row.open)} = ${stage.rate}%` },
      "成功安装数": { logic: "成功安装率 = 成功安装数 ÷ 点击安装数", formula: `${UI.fmtNum(row.installSuccess)} ÷ ${UI.fmtNum(row.installStart)} = ${stage.rate}%` },
      "成功回流数": { logic: "成功回流率 = 成功回流数 ÷ 点击回流数", formula: `${UI.fmtNum(row.reflowSuccess)} ÷ ${UI.fmtNum(row.reflowStart)} = ${stage.rate}%` },
    };
    return formulas[stage.name] || null;
  };
  const rateTooltip = (stage, align = "center") => {
    const formula = getRateFormula(stage);
    if (!formula) return "";
    const position = align === "right" ? "right-0 top-full mt-2" : "left-1/2 bottom-full mb-2 -translate-x-1/2";
    return `
      <div class="pointer-events-none absolute ${position} z-30 w-64 rounded-xl border border-ink-200 bg-white px-3 py-2 text-left shadow-pop opacity-0 translate-y-1 transition-all duration-150 group-hover:opacity-100 group-hover:translate-y-0">
        <div class="text-[11px] font-semibold text-ink-500">计算逻辑</div>
        <div class="mt-1 text-xs font-semibold text-ink-900">${formula.logic}</div>
        <div class="mt-1 rounded-lg bg-ink-50 px-2 py-1 num text-[11px] font-semibold text-brand-700">${formula.formula}</div>
      </div>
    `;
  };
  const branchTile = (stage, tone = "blue") => {
    const style = branchStyle[tone] || branchStyle.blue;
    const formula = getRateFormula(stage);
    return `
      <div class="group relative h-[58px] rounded-lg border px-2.5 py-2 shadow-sm cursor-help" title="${formula ? `${formula.logic}；${formula.formula}` : ""}" style="background:${style.bg}; border-color:${style.border};">
        <div class="flex items-center justify-between gap-2 leading-none">
          <span class="text-[11px] font-semibold text-ink-700 whitespace-nowrap">${stage.name}</span>
          <span class="num text-sm font-bold" style="color:${style.color};">${stage.rate}%</span>
        </div>
        <div class="mt-1.5 flex items-end justify-between gap-2 leading-none">
          <span class="num text-sm font-semibold text-ink-900">${UI.fmtNum(stage.value)}</span>
          <span class="text-[10px] font-medium whitespace-nowrap" style="color:${style.color};">${stage.rateLabel}</span>
        </div>
        ${rateTooltip(stage)}
      </div>
    `;
  };
  const rateBadge = (stage) => {
    const formula = getRateFormula(stage);
    return stage.rateLabel ? `
      <div class="group relative rounded-xl border border-brand-100 bg-brand-50 px-3 py-2 text-right cursor-help" title="${formula ? `${formula.logic}；${formula.formula}` : ""}">
        <div class="text-[11px] font-semibold text-brand-700">${stage.rateLabel}</div>
        <div class="num text-xl font-bold text-brand-900 leading-tight">${stage.rate}%</div>
        ${rateTooltip(stage, "right")}
      </div>
    ` : `<div class="h-11"></div>`;
  };
  const funnelLayer = (stage, width, gradient, branches = []) => `
    <div class="relative">
      <div class="grid h-11 items-center gap-3" style="grid-template-columns:116px minmax(0,1fr) 124px;">
        <div class="text-right min-w-0">
          <div class="text-xs font-semibold text-ink-700 truncate">${stage.name}</div>
          <div class="num text-xl font-bold text-ink-900 leading-tight">${UI.fmtNum(stage.value)}</div>
          ${stage.desc ? `<div class="text-[10px] text-ink-400 truncate">${stage.desc}</div>` : ""}
        </div>
        <div class="relative h-11 flex items-center justify-center">
          <div class="absolute left-1/2 -translate-x-1/2 top-[-7px] bottom-[-7px] w-px bg-white/80"></div>
          ${stage.rateLabel ? `<div class="absolute top-1/2 z-0 h-px -translate-y-1/2 border-t border-dashed border-brand-300" style="left:calc(50% + ${width / 2}% - 2px); right:-12px;"></div><div class="absolute top-1/2 z-10 h-2 w-2 -translate-y-1/2 rounded-full border-2 border-white bg-brand-500 shadow-sm" style="left:calc(50% + ${width / 2}% - 4px);"></div><div class="absolute -right-4 top-1/2 z-10 -translate-y-1/2 rounded-full bg-brand-50 px-1.5 text-[10px] font-bold text-brand-600">→</div>` : ""}
          <div class="relative z-10 h-11 shadow-sm ring-1 ring-white/70" style="width:${width}%; background:${gradient}; clip-path: polygon(5% 0, 95% 0, 87% 100%, 13% 100%);"></div>
        </div>
        ${rateBadge(stage)}
      </div>
      ${branches.length ? `
        <div class="mt-5 mb-1 grid gap-3" style="grid-template-columns:116px minmax(0,1fr) 124px;">
          <div></div>
          <div class="flex justify-center">
            <div class="relative h-[70px] rounded-2xl border border-dashed border-ink-200 bg-white/85 p-2.5 shadow-sm" style="width:${Math.max(46, Math.round(width * 0.78))}%;">
              <div class="absolute left-1/2 top-0 h-5 w-px -translate-x-1/2 -translate-y-5 border-l border-dashed border-ink-300"></div>
              <div class="grid grid-cols-2 gap-2">${branches.join("")}</div>
            </div>
          </div>
          <div></div>
        </div>
      ` : ""}
    </div>
  `;
  const renderSdkMainRow = (item) => `
    <div class="grid h-11 items-center gap-2 border-l-4 border-y border-r border-ink-100 bg-white px-3 text-xs shadow-sm" style="grid-template-columns:1fr repeat(4,.72fr); border-left-color:${item.color};">
      <div class="font-semibold text-ink-900 truncate">${item.label}</div>
      ${[["iOS", item.ios], ["安卓", item.android], ["其它", item.other], ["总计", item.total]].map(([label, value], idx) => `
        <div class="text-right leading-tight">
          <div class="text-[9px] font-semibold text-ink-400">${label}</div>
          <div class="num ${idx === 3 ? "font-bold text-ink-900" : "font-semibold text-ink-700"}">${UI.fmtNum(value)}</div>
        </div>
      `).join("")}
    </div>
  `;
  const renderSdkBranch = (item) => `
    <div class="h-[58px] bg-white/80 py-2 px-2">
      <div class="text-[11px] font-semibold text-ink-800 whitespace-nowrap leading-none">${item.label}</div>
      <div class="mt-1.5 grid grid-cols-4 gap-1 text-[10px] leading-tight">
        ${[["iOS", item.ios], ["安卓", item.android], ["其它", item.other], ["总", item.total]].map(([label, value], idx) => `
          <div class="text-right">
            <div class="text-ink-400">${label}</div>
            <div class="num ${idx === 3 ? "font-bold text-ink-900" : "font-semibold text-ink-700"}">${UI.fmtNum(value)}</div>
          </div>
        `).join("")}
      </div>
    </div>
  `;
  return `
    <div class="p-4 bg-ink-50/60">
      <div class="grid grid-cols-12 gap-4 items-stretch">
        <section class="col-span-4 h-full rounded-2xl border border-ink-100 bg-white shadow-soft overflow-hidden flex flex-col">
          <div class="px-4 py-3 bg-ink-50 border-b border-ink-100">
            <div class="text-sm font-semibold text-ink-900">SDK 平台拆解</div>
            <div class="text-xs text-ink-500 mt-0.5">对应右侧漏斗阶段 · Steam 计入其它平台</div>
          </div>
          <div class="flex-1 p-4" style="background:linear-gradient(180deg,#F8FBFF 0%,#FFFFFF 72%);">
            <div class="rounded-2xl border border-ink-100 bg-white/90 p-4 shadow-sm">
              <div class="space-y-2">
                ${sdkFunnelRows.map((stage) => `
                  <div class="relative">
                    ${renderSdkMainRow(stage.main)}
                    ${stage.branches.length ? `
                      <div class="relative mt-5 mb-1 h-[70px] rounded-2xl border border-dashed border-ink-200 bg-ink-50/80 p-2.5 shadow-sm">
                        <div class="absolute left-1/2 top-0 h-5 w-px -translate-x-1/2 -translate-y-5 border-l border-dashed border-ink-300"></div>
                        <div class="grid grid-cols-2 gap-2">${stage.branches.map(renderSdkBranch).join("")}</div>
                      </div>
                    ` : ""}
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
        </section>

        <section class="col-span-8 h-full rounded-2xl border border-ink-100 bg-white shadow-soft overflow-hidden">
          <div class="px-5 py-3 border-b border-ink-100 flex items-center justify-between">
            <div>
              <div class="text-sm font-semibold text-ink-900">转化率漏斗</div>
              <div class="text-xs text-ink-500 mt-0.5">分享 → 打开 → Action → 总成功</div>
            </div>
            <span class="badge bg-brand-50 text-brand-700">Funnel</span>
          </div>
          <div class="p-4" style="background:linear-gradient(180deg,#F8FBFF 0%,#FFFFFF 72%);">
            <div class="rounded-2xl border border-ink-100 bg-white/90 p-4 shadow-sm">
              <div class="space-y-2">
                ${funnelLayer(groups.main[0], 100, "linear-gradient(90deg,#0F2A6B,#1E40AF)")}
                ${funnelLayer(groups.main[1], 86, "linear-gradient(90deg,#1D4ED8,#60A5FA)")}
                ${funnelLayer(groups.main[2], 70, "linear-gradient(90deg,#0284C7,#38BDF8)", [branchTile(groups.install[0], "blue"), branchTile(groups.reflow[0], "amber")])}
                ${funnelLayer(groups.main[3], 54, "linear-gradient(90deg,#0F766E,#14B8A6)", [branchTile(groups.install[1], "green"), branchTile(groups.reflow[1], "orange")])}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  `;
}

function renderShareDataBreakdownColgroup() {
  return `<colgroup><col style="width:220px" />${Array.from({ length: 11 }, () => `<col style="width:116px" />`).join("")}</colgroup>`;
}

function renderShareDataBreakdownHeader(firstLabel) {
  const headers = [firstLabel, "分享数", "打开数", "打开转化率", "点击安装数", "点击安装率", "成功安装数", "成功安装率", "点击回流数", "点击回流率", "成功回流数", "成功回流率"];
  return `<thead class="bg-ink-50 text-xs text-ink-500 border-b border-ink-100"><tr>${headers.map((label, idx) => `<th class="px-4 py-3 ${idx === 0 ? "text-left" : "text-right"} font-medium whitespace-nowrap">${label}</th>`).join("")}</tr></thead>`;
}

function renderShareDataBreakdownRow(row) {
  const openRate = Number(((row.open / Math.max(1, row.share)) * 100).toFixed(1));
  const installClickRate = Number(((row.installStart / Math.max(1, row.open)) * 100).toFixed(1));
  const installSuccessRate = Number(((row.installSuccess / Math.max(1, row.installStart)) * 100).toFixed(1));
  const reflowClickRate = Number(((row.reflowStart / Math.max(1, row.open)) * 100).toFixed(1));
  const reflowSuccessRate = Number(((row.reflowSuccess / Math.max(1, row.reflowStart)) * 100).toFixed(1));
  const cells = [
    UI.fmtNum(row.share),
    UI.fmtNum(row.open),
    `${openRate}%`,
    UI.fmtNum(row.installStart),
    `${installClickRate}%`,
    UI.fmtNum(row.installSuccess),
    `${installSuccessRate}%`,
    UI.fmtNum(row.reflowStart),
    `${reflowClickRate}%`,
    UI.fmtNum(row.reflowSuccess),
    `${reflowSuccessRate}%`,
  ];
  const isAnomaly = (idx) => {
    if (idx === 2) return openRate < 24;
    if (idx === 4) return installClickRate < 32;
    if (idx === 6) return installSuccessRate < 55;
    if (idx === 8) return reflowClickRate < 11;
    if (idx === 10) return reflowSuccessRate < 45;
    return false;
  };
  const tone = ["", "", "text-brand-700 font-semibold", "", "text-brand-700 font-semibold", "text-ok-700", "text-brand-700 font-semibold", "", "text-brand-700 font-semibold", "text-ok-700", "text-brand-700 font-semibold"];
  const cellClass = (idx) => isAnomaly(idx) ? "text-danger-600 font-semibold bg-danger-50" : tone[idx];
  const rateTip = (idx) => isAnomaly(idx) ? " title=\"该分支转化率明显低于整体合理区间，请重点排查\"" : "";
  return `<tr class="border-b last:border-b-0 border-ink-100 row-hover"><td class="px-4 py-3 font-medium text-ink-900"><div class="truncate" title="${row.name}">${row.name}</div></td>${cells.map((value, idx) => `<td${rateTip(idx)} class="px-4 py-3 text-right num whitespace-nowrap ${cellClass(idx)}">${value}</td>`).join("")}</tr>`;
}

function renderShareDataPackageRow(row) {
  return renderShareDataBreakdownRow(row);
}

function renderShareDataSceneRow(row) {
  return renderShareDataBreakdownRow(row);
}

function renderShareDataChannelRow(row) {
  return renderShareDataBreakdownRow(row);
}

function renderShareDataLanguageDetailRow(row) {
  return renderShareDataBreakdownRow(row);
}

function renderShareDataCountryRow(row) {
  return renderShareDataBreakdownRow(row);
}

function renderShareDataDeviceModelRow(row) {
  return renderShareDataBreakdownRow(row);
}

function renderShareDataDetailCharts(row) {
  const dates = getShareDataDetailRangeDates();
  const range = getShareDataDetailTimeRange();
  const label = document.getElementById("share-detail-time-label");
  if (label) label.textContent = range.label;
  const makeTrend = (base, amp, offset) => dates.map((_date, idx) => Math.max(0, Math.round(base / dates.length * (1 + Math.sin((idx + offset) / 2) * amp + idx * 0.015))));
  const shareTrend = makeTrend(row.share, 0.12, 1);
  const openTrend = makeTrend(row.open, 0.14, 2);
  const installStartTrend = makeTrend(row.installStart, 0.15, 3);
  const reflowStartTrend = makeTrend(row.reflowStart, 0.16, 4);
  const installSuccessTrend = makeTrend(row.installSuccess, 0.16, 5);
  const reflowSuccessTrend = makeTrend(row.reflowSuccess, 0.18, 6);
  const markY = Math.max(...shareTrend, 1) * 1.08;
  const updateMarks = typeof window.getShareActivityUpdateTrendMarks === "function"
    ? window.getShareActivityUpdateTrendMarks(dates, row.id).map((mark) => ({ ...mark, value: [mark.value?.[0], markY] }))
    : [];
  const trendEl = document.getElementById("share-detail-trend");
  if (trendEl && window.echarts) {
    if (trendEl.clientWidth === 0) {
      requestAnimationFrame(() => renderShareDataDetailCharts(row));
      return;
    }
    const chart = echarts.getInstanceByDom(trendEl) || echarts.init(trendEl);
    chart.resize();
    chart.setOption({
      grid: { top: 44, right: 24, bottom: 36, left: 56 },
      tooltip: UI.chartTooltip(),
      legend: { top: 12, left: 20, itemWidth: 10, itemHeight: 10, icon: "circle", textStyle: { color: "#64748B", fontSize: 12 } },
      xAxis: UI.chartXAxis(dates),
      yAxis: UI.chartYAxis(),
      series: [
        UI.chartLineSeries("分享数", shareTrend, { color: "#1E3A8A", area: true }),
        UI.chartLineSeries("打开数", openTrend, { color: "#2563EB" }),
        UI.chartLineSeries("点击安装数", installStartTrend, { color: "#38BDF8" }),
        UI.chartLineSeries("点击回流数", reflowStartTrend, { color: "#D97706" }),
        UI.chartLineSeries("成功安装数", installSuccessTrend, { color: "#0F766E" }),
        UI.chartLineSeries("成功回流数", reflowSuccessTrend, { color: "#B45309" }),
        ...(updateMarks.length ? [{
          name: "配置变化点",
          type: "scatter",
          data: updateMarks,
          symbol: "pin",
          symbolSize: 30,
          itemStyle: { color: "#7C3AED" },
          label: {
            show: true,
            formatter: (p) => p.data?.label || "配置更新",
            position: "top",
            color: "#6D28D9",
            fontSize: 10,
            fontWeight: 500,
            backgroundColor: "#F5F3FF",
            borderColor: "#DDD6FE",
            borderWidth: 1,
            borderRadius: 3,
            padding: [2, 4],
          },
          tooltip: {
            formatter: (p) => {
              const logs = p.data?.logs || [];
              return `<b>${p.data?.label || p.name}</b><br/>${p.data?.value?.[0] || ""}<br/>${logs.map((log) => `${log.operationTime} ${log.trendLabel || log.action}<br/><span style="color:#94a3b8">${log.detail}</span>`).join("<br/>")}`;
            },
          },
          z: 5,
        }] : []),
      ],
    }, true);
    setTimeout(() => chart.resize(), 0);
  }

}

// ---------- 漏斗分析 ----------
Pages.funnelAnalysis = function () {
  const data = MOCK.FUNNEL_DATA;
  const levels = MOCK.FUNNEL_LEVELS;
  let maxDropIdx = 0, maxDrop = 0;
  for (let i = 1; i < data.length; i++) {
    const drop = data[i - 1].times - data[i].times;
    if (drop > maxDrop) { maxDrop = drop; maxDropIdx = i; }
  }
  const total = data[0].times;

  PageHooks.mounted = () => {
    const el = document.getElementById("funnel-shape");
    if (el) {
      const chart = echarts.init(el);
      chart.setOption({
        tooltip: { ...UI.chartTooltip(), trigger: "item", formatter: (p) => `${p.name}<br/><b style="font-size:14px">${UI.fmtNum(p.value)}</b> 次` },
        series: [
          {
            type: "funnel",
            left: "10%", right: "10%", top: 10, bottom: 10,
            minSize: "20%", maxSize: "100%",
            sort: "descending",
            gap: 4,
            label: { show: true, position: "inside", color: "#fff", fontSize: 12, fontWeight: 600, formatter: "{b}\n{c}" },
            labelLine: { show: false },
            itemStyle: { borderColor: "#fff", borderWidth: 2 },
            data: data.map((d, i) => ({
              value: d.times,
              name: levels[i].name,
              itemStyle: {
                color: {
                  type: "linear", x: 0, y: 0, x2: 1, y2: 0,
                  colorStops: [
                    { offset: 0, color: ["#7C3AED", "#8B5CF6", "#A78BFA", "#06B6D4", "#10B981", "#34D399", "#F59E0B", "#FB923C", "#EC4899"][i] },
                    { offset: 1, color: ["#EC4899", "#7C3AED", "#8B5CF6", "#22D3EE", "#34D399", "#10B981", "#FBBF24", "#F59E0B", "#F472B6"][i] },
                  ],
                },
                shadowColor: "rgba(124,58,237,0.2)", shadowBlur: 10,
              },
            })),
          },
        ],
      });
      window.addEventListener("resize", () => chart.resize());
    }
  };

  return `
    ${UI.pageHeader({
      title: "漏斗分析",
      desc: "8 层完整漏斗追踪 · 从分享到付费的全链路转化",
      icon: "🔻",
      actions: `${UI.ghostBtn("📥 导出数据", { onclick: "UI.toast('已开始导出，10 秒内自动下载', 'info')" })}`,
    })}

    ${renderAnalyticsFilters()}

    <!-- 顶部 KPI -->
    <div class="grid grid-cols-4 gap-4 mb-4">
      ${UI.statCard({ label: "总分享次数", value: UI.fmtNum(data[0].times), delta: 12, icon: "📤", color: "brand" })}
      ${UI.statCard({ label: "总转化率（→付费）", value: ((data[8].times / data[0].times) * 100).toFixed(2) + "%", delta: 5, icon: "📈", color: "green" })}
      ${UI.statCard({ label: "付费 ARPU", value: UI.fmtMoney(12.5), delta: 18, icon: "💎", color: "amber" })}
      ${UI.statCard({ label: "总收入", value: UI.fmtMoney(data[8].amount || 22875), delta: 22, icon: "💰", color: "pink" })}
    </div>

    <!-- 漏斗双视图 -->
    <div class="grid grid-cols-5 gap-4 mb-4">
      <!-- 左：渐变条形漏斗 -->
      <div class="col-span-3 card p-6 relative overflow-hidden">
        <div class="absolute -right-8 -top-8 w-40 h-40 rounded-full opacity-10 bg-brand-900"></div>
        <div class="relative flex items-center justify-between mb-5">
          <div>
            <h3 class="text-sm font-bold text-ink-900">分享漏斗 · 最近 7 天</h3>
            <p class="text-xs text-ink-500 mt-0.5">按 ref_code 串联的全链路用户行为</p>
          </div>
          <div class="flex items-center gap-3 text-xs">
            <span class="flex items-center gap-1.5 text-ink-500"><span class="w-2 h-2 rounded-full bg-brand-500"></span>次数</span>
            <span class="flex items-center gap-1.5 text-ink-500"><span class="w-2 h-2 rounded-full bg-emerald-500"></span>人数</span>
          </div>
        </div>

        <div class="relative space-y-2.5">
          ${data.map((d, i) => {
            const lv = levels[i];
            const widthPct = (d.times / total) * 100;
            const isMaxDrop = i === maxDropIdx && i > 0;
            const dropRate = i > 0 ? (((data[i - 1].times - d.times) / data[i - 1].times) * 100).toFixed(1) : 0;
            const colors = [
              "bg-brand-900",
              "bg-brand-800",
              "bg-brand-700",
              "bg-brand-600",
              "bg-brand-500",
              "bg-ink-700",
              "bg-ink-600",
              "bg-warn-600",
              "bg-warn-700",
            ];
            return `
              <div class="funnel-row">
                ${i > 0 ? `<div class="flex items-center justify-end gap-1.5 text-[10px] text-ink-400 pr-3 mb-1">
                  <span class="num">↓ ${(100 - dropRate).toFixed(1)}%</span>
                  <span>转化 · 流失</span>
                  <span class="num ${isMaxDrop ? "text-danger-600 font-bold" : ""}">${dropRate}%</span>
                  ${isMaxDrop ? `<span class="px-1.5 py-0.5 bg-danger-50 text-danger-700 rounded font-semibold ml-1">最大流失点</span>` : ""}
                </div>` : ""}
                <div class="flex items-center gap-3">
                  <div class="w-24 flex items-center gap-2 flex-shrink-0">
                    <span class="w-7 h-7 rounded-md ${colors[i]} text-white text-xs font-semibold flex items-center justify-center">${i + 1}</span>
                    <div>
                      <div class="text-xs font-semibold text-ink-900">${lv.name}</div>
                      <div class="text-[10px] text-ink-400">${lv.en}</div>
                    </div>
                  </div>
                  <div class="flex-1 relative h-9 bg-ink-100 rounded-md overflow-hidden">
                    <div class="absolute inset-y-0 left-0 rounded-md ${colors[i]} flex items-center justify-end pr-3 ${isMaxDrop ? "ring-2 ring-danger-300 ring-offset-1" : ""}" style="width: ${widthPct}%; transition: width .6s ease;">
                      <span class="num text-xs font-bold text-white">${UI.fmtNum(d.times)}</span>
                    </div>
                  </div>
                  <div class="w-28 text-right flex-shrink-0">
                    <div class="num text-sm font-bold text-ink-900">${UI.fmtNum(d.times)}<span class="text-xs text-ink-400 font-normal"> 次</span></div>
                    <div class="num text-xs text-emerald-600">${UI.fmtNum(d.people)} 人</div>
                  </div>
                </div>
              </div>
            `;
          }).join("")}
        </div>
      </div>

      <!-- 右：经典漏斗形状 + 详细表 -->
      <div class="col-span-2 space-y-4">
        <div class="card p-5">
          <h3 class="text-sm font-bold text-ink-900 mb-3">漏斗形状视图</h3>
          <div id="funnel-shape" style="height: 320px;"></div>
        </div>

        <!-- 智能洞察 -->
        <div class="rounded-2xl p-5 bg-warn-50 border border-amber-200 relative overflow-hidden">
          <div class="absolute -right-4 -top-4 w-20 h-20 rounded-full bg-amber-200/40 blur-xl"></div>
          <div class="relative">
            <div class="text-sm font-bold text-amber-900 flex items-center gap-1.5 mb-2">
              <span class="w-7 h-7 rounded-lg bg-warn-600 text-white flex items-center justify-center text-sm shadow-soft">🤖</span>
              智能洞察
            </div>
            <p class="text-xs text-amber-900 leading-relaxed">
              <strong>${levels[maxDropIdx].name}</strong>（${levels[maxDropIdx].en}）层流失最严重。建议：
            </p>
            <ul class="text-xs text-amber-800 mt-2 space-y-1.5 ml-4 list-disc">
              <li>检查落地页加载速度（海外 CDN 是否覆盖）</li>
              <li>检查 deep link 唤起成功率，确认 fallback_url 配置</li>
              <li>对该渠道做 A/B 测试，调整文案与图片</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 详细数据表 -->
    <div class="card overflow-hidden">
      <div class="px-6 py-4 border-b border-ink-100 flex items-center justify-between">
        <h3 class="text-sm font-bold text-ink-900">详细数据表</h3>
        <div class="flex gap-1 text-xs p-1 bg-ink-50 rounded-lg">
          <button class="px-3 py-1 rounded-md bg-white text-brand-700 font-semibold shadow-soft">绝对值</button>
          <button class="px-3 py-1 rounded-md text-ink-500 hover:bg-white">百分比</button>
        </div>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-6 py-3 font-semibold">层级</th>
            <th class="text-right px-4 py-3 font-semibold">次数</th>
            <th class="text-right px-4 py-3 font-semibold">人数</th>
            <th class="text-right px-4 py-3 font-semibold">本层转化率</th>
            <th class="text-right px-4 py-3 font-semibold">总体保留率</th>
            <th class="text-right px-6 py-3 font-semibold">流失率</th>
          </tr>
        </thead>
        <tbody>
          ${data.map((d, i) => {
            const lv = levels[i];
            const isMaxDrop = i === maxDropIdx && i > 0;
            const dropRate = i > 0 ? (((data[i - 1].times - d.times) / data[i - 1].times) * 100).toFixed(1) : 0;
            const retain = ((d.times / total) * 100).toFixed(2);
            return `
              <tr class="border-t border-ink-100 row-hover ${isMaxDrop ? "bg-rose-50/40" : ""}">
                <td class="px-6 py-3">
                  <div class="flex items-center gap-2">
                    <span class="w-6 h-6 rounded-md bg-brand-50 border border-brand-100 text-brand-700 text-xs font-bold flex items-center justify-center">${i + 1}</span>
                    <span class="font-medium">${lv.name}</span>
                    <span class="text-[10px] text-ink-400">${lv.en}</span>
                  </div>
                </td>
                <td class="px-4 py-3 text-right num font-semibold">${UI.fmtNum(d.times)}</td>
                <td class="px-4 py-3 text-right num text-ink-500">${UI.fmtNum(d.people)}</td>
                <td class="px-4 py-3 text-right num text-emerald-600 font-semibold">${i === 0 ? "100%" : (100 - dropRate).toFixed(1) + "%"}</td>
                <td class="px-4 py-3 text-right num text-ink-700">${retain}%</td>
                <td class="px-6 py-3 text-right num ${isMaxDrop ? "text-rose-600 font-bold" : "text-ink-500"}">${i === 0 ? "—" : dropRate + "%"}</td>
              </tr>`;
          }).join("")}
        </tbody>
      </table>
    </div>
  `;
};

// ---------- 筛选器（升级） ----------
function renderAnalyticsFilters() {
  return `
    ${renderOpsModuleTabs("analytics")}
    ${renderOpsWorkflowHint("analytics")}
    <div class="card p-4 mb-4 flex items-center gap-3 flex-wrap">
      ${filterChip("时间", ["今天", "昨天", "最近 7 天", "最近 30 天", "自定义"], 2)}
      ${filterChip("游戏", ["全部", ...MOCK.GAMES.map(g => g.name)], 0)}
      ${filterChip("包体", ["全部"], 0)}
      ${filterChip("渠道", ["全部", ...MOCK.CHANNELS.filter(c => c.enabled).map(c => c.icon + " " + c.name)], 0)}
      ${filterChip("地区", ["全部", ...(window.EASYSHARE_REGION_OPTIONS || []).map(r => `${r.code} · ${(window.regionNameFromCode ? window.regionNameFromCode(r.code) : r.name)}`)], 0)}
      <div class="flex-1"></div>
      ${UI.primaryBtn("应用筛选")}
      ${UI.ghostBtn("重置")}
    </div>
  `;
}
function filterChip(label, opts, defaultIdx) {
  return `
    <div class="flex items-center gap-1.5">
      <span class="text-xs text-ink-500">${label}</span>
      <select class="text-sm border border-ink-200 rounded-lg px-2.5 py-1.5 bg-white hover:border-brand-300 focus:border-brand-500 focus:ring-2 focus:ring-brand-100 outline-none transition">
        ${opts.map((o, i) => `<option ${i === defaultIdx ? "selected" : ""}>${o}</option>`).join("")}
      </select>
    </div>
  `;
}

// ---------- 渠道对比 ----------
Pages.channelCompare = function () {
  PageHooks.mounted = () => {
    const channels = MOCK.CHANNEL_COMPARE;

    const el = document.getElementById("channel-bar");
    if (el) {
      const chart = echarts.init(el);
      chart.setOption({
        grid: { top: 40, right: 16, bottom: 36, left: 56 },
        tooltip: { ...UI.chartTooltip(), axisPointer: { type: "shadow" } },
        legend: { data: ["分享", "点击", "安装"], top: 0, itemWidth: 10, itemHeight: 10, icon: "circle", textStyle: { color: "#6B7280", fontSize: 12 } },
        xAxis: { ...UI.chartXAxis(channels.map(c => c.name)), boundaryGap: true },
        yAxis: UI.chartYAxis(),
        series: [
          UI.chartBarSeries("分享", channels.map(c => c.share), { color: "#7C3AED", colorTo: "#A78BFA", barWidth: 14 }),
          UI.chartBarSeries("点击", channels.map(c => Math.floor(c.share * c.click_rate / 100)), { color: "#10B981", colorTo: "#34D399", barWidth: 14 }),
          UI.chartBarSeries("安装", channels.map(c => c.install), { color: "#F59E0B", colorTo: "#FBBF24", barWidth: 14 }),
        ],
      });
      window.addEventListener("resize", () => chart.resize());
    }

    const el2 = document.getElementById("channel-roi");
    if (el2) {
      const c2 = echarts.init(el2);
      c2.setOption({
        grid: { top: 40, right: 56, bottom: 36, left: 56 },
        tooltip: UI.chartTooltip(),
        legend: { data: ["ROI", "CPI"], top: 0, itemWidth: 10, itemHeight: 10, icon: "circle", textStyle: { color: "#6B7280", fontSize: 12 } },
        xAxis: { ...UI.chartXAxis(channels.map(c => c.name)), boundaryGap: true },
        yAxis: [
          UI.chartYAxis({ name: "ROI (%)", nameTextStyle: { color: "#9CA3AF", fontSize: 11 } }),
          UI.chartYAxis({ name: "CPI ($)", nameTextStyle: { color: "#9CA3AF", fontSize: 11 }, axisLabel: { color: "#9CA3AF", fontSize: 11, formatter: "${value}" } }),
        ],
        series: [
          UI.chartBarSeries("ROI", channels.map(c => c.roi), { color: "#7C3AED", colorTo: "#EC4899", barWidth: 16 }),
          { ...UI.chartLineSeries("CPI", channels.map(c => c.cpi), { color: "#F43F5E", area: false }), yAxisIndex: 1, showSymbol: true, symbolSize: 8 },
        ],
      });
      window.addEventListener("resize", () => c2.resize());
    }
  };

  const channels = MOCK.CHANNEL_COMPARE;
  const bestRoi = channels.reduce((a, b) => (a.roi > b.roi ? a : b));
  const bestClickRate = channels.reduce((a, b) => (a.click_rate > b.click_rate ? a : b));

  return `
    ${UI.pageHeader({
      title: "渠道对比分析",
      desc: "找到最有效的传播渠道，优化获客 ROI",
      icon: "🌐",
      actions: UI.ghostBtn("📥 导出对比报表"),
    })}

    ${renderAnalyticsFilters()}

    <!-- Highlight Cards -->
    <div class="grid grid-cols-3 gap-4 mb-4">
      ${highlightCard({ tag: "🏆 最佳 ROI", title: bestRoi.name, value: bestRoi.roi + "%", sub: `CPI ${UI.fmtMoney(bestRoi.cpi)} · ${UI.fmtNum(bestRoi.install)} 安装`, gradient: "from-ok-500 to-brand-700", icon: MOCK.CHANNELS.find(c => c.code === bestRoi.code)?.icon })}
      ${highlightCard({ tag: "📈 最高点击率", title: bestClickRate.name, value: bestClickRate.click_rate + "%", sub: "用户对该渠道兴趣最高", gradient: "from-brand-600 to-brand-700", icon: MOCK.CHANNELS.find(c => c.code === bestClickRate.code)?.icon })}
      ${highlightCard({ tag: "💡 智能建议", title: "WhatsApp", value: "18%", sub: "分享量大但点击率偏低，建议优化文案", gradient: "from-warn-500 to-brand-700", icon: "📱" })}
    </div>

    <!-- 双图表 -->
    <div class="grid grid-cols-2 gap-4 mb-4">
      <div class="card p-6">
        <h3 class="text-sm font-bold text-ink-900 mb-3">各渠道分享 / 点击 / 安装对比</h3>
        <div id="channel-bar" style="height: 300px;"></div>
      </div>
      <div class="card p-6">
        <h3 class="text-sm font-bold text-ink-900 mb-3">ROI vs CPI 对比</h3>
        <div id="channel-roi" style="height: 300px;"></div>
      </div>
    </div>

    <!-- 详细对比表 -->
    <div class="card overflow-hidden">
      <div class="px-6 py-4 border-b border-ink-100">
        <h3 class="text-sm font-bold text-ink-900">详细对比表</h3>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-6 py-3 font-semibold">渠道</th>
            <th class="text-right px-4 py-3 font-semibold">分享数</th>
            <th class="text-right px-4 py-3 font-semibold">点击率</th>
            <th class="text-right px-4 py-3 font-semibold">安装数</th>
            <th class="text-right px-4 py-3 font-semibold">CPI</th>
            <th class="text-right px-4 py-3 font-semibold">ROI</th>
            <th class="text-right px-4 py-3 font-semibold">D1 留存</th>
            <th class="text-right px-4 py-3 font-semibold">D7 留存</th>
            <th class="text-right px-6 py-3 font-semibold">D30 留存</th>
          </tr>
        </thead>
        <tbody>
          ${channels.map(c => {
            const ch = MOCK.CHANNELS.find(x => x.code === c.code);
            const isBest = c.code === bestRoi.code;
            return `
              <tr class="border-t border-ink-100 row-hover ${isBest ? "bg-emerald-50/30" : ""}">
                <td class="px-6 py-3">
                  <div class="flex items-center gap-2">
                    <span class="text-base">${ch?.icon}</span>
                    <span class="font-medium">${c.name}</span>
                    ${isBest ? '<span class="badge bg-emerald-100 text-emerald-700">🏆 最佳</span>' : ""}
                  </div>
                </td>
                <td class="px-4 py-3 text-right num">${UI.fmtNum(c.share)}</td>
                <td class="px-4 py-3 text-right"><span class="badge bg-cyan-50 text-cyan-700 num">${c.click_rate}%</span></td>
                <td class="px-4 py-3 text-right num">${UI.fmtNum(c.install)}</td>
                <td class="px-4 py-3 text-right num">${UI.fmtMoney(c.cpi)}</td>
                <td class="px-4 py-3 text-right num font-bold text-emerald-600">${c.roi}%</td>
                <td class="px-4 py-3 text-right num text-ink-500">${c.retention.d1}%</td>
                <td class="px-4 py-3 text-right num text-ink-500">${c.retention.d7}%</td>
                <td class="px-6 py-3 text-right num text-ink-500">${c.retention.d30}%</td>
              </tr>`;
          }).join("")}
        </tbody>
      </table>
    </div>
  `;
};

function highlightCard({ tag, title, value, sub, gradient, icon }) {
  return `
    <div class="relative overflow-hidden rounded-2xl p-5 bg-ink-100 text-white shadow-soft">
      <div class="absolute -right-6 -top-6 w-28 h-28 rounded-full bg-white/10"></div>
      <div class="absolute -right-2 -bottom-8 text-6xl opacity-30">${icon || ""}</div>
      <div class="relative">
        <div class="text-xs font-medium opacity-90">${tag}</div>
        <div class="mt-2 flex items-baseline gap-2">
          <span class="text-lg font-bold">${title}</span>
        </div>
        <div class="num text-[34px] font-extrabold mt-1 leading-none">${value}</div>
        <div class="text-xs opacity-85 mt-2">${sub}</div>
      </div>
    </div>
  `;
}

// ---------- 趋势分析 ----------
Pages.trends = function () {
  PageHooks.mounted = () => {
    const el = document.getElementById("trend-main");
    if (el) {
      const chart = echarts.init(el);
      chart.setOption({
        grid: { top: 40, right: 24, bottom: 36, left: 56 },
        tooltip: UI.chartTooltip(),
        legend: { data: ["分享", "点击", "安装", "付费"], top: 0, itemWidth: 10, itemHeight: 10, icon: "circle", textStyle: { color: "#6B7280", fontSize: 12 } },
        xAxis: UI.chartXAxis(MOCK.TREND_DATA.dates),
        yAxis: UI.chartYAxis(),
        series: [
          UI.chartLineSeries("分享", MOCK.TREND_DATA.share, { color: "#7C3AED", area: true }),
          UI.chartLineSeries("点击", MOCK.TREND_DATA.click, { color: "#10B981" }),
          UI.chartLineSeries("安装", MOCK.TREND_DATA.install, { color: "#F59E0B" }),
          UI.chartLineSeries("付费", MOCK.TREND_DATA.purchase, { color: "#EC4899" }),
        ],
      });
      window.addEventListener("resize", () => chart.resize());
    }

    const el2 = document.getElementById("trend-rate");
    if (el2) {
      const c2 = echarts.init(el2);
      c2.setOption({
        grid: { top: 30, right: 16, bottom: 30, left: 50 },
        tooltip: UI.chartTooltip(),
        xAxis: UI.chartXAxis(MOCK.TREND_DATA.dates),
        yAxis: UI.chartYAxis({ axisLabel: { formatter: "{value}%", color: "#9CA3AF", fontSize: 11 } }),
        series: [
          {
            ...UI.chartLineSeries("转化率", MOCK.TREND_DATA.share.map((s, i) => +(((MOCK.TREND_DATA.purchase[i] / s) * 100).toFixed(2))), { color: "#7C3AED", colorTo: "#EC4899", area: true }),
            markLine: {
              symbol: "none",
              lineStyle: { color: "#9CA3AF", type: "dashed", width: 1 },
              label: { color: "#9CA3AF", fontSize: 10 },
              data: [{ type: "average", name: "均值" }],
            },
          },
        ],
      });
      window.addEventListener("resize", () => c2.resize());
    }
  };

  return `
    ${UI.pageHeader({ title: "趋势分析", desc: "时间维度的数据走势与异常预警", icon: "📈" })}

    ${renderAnalyticsFilters()}

    <!-- 异常预警 -->
    <div class="relative overflow-hidden rounded-2xl p-5 mb-4 bg-danger-50 border border-rose-200 flex items-start gap-3">
      <div class="absolute -right-4 -top-4 w-20 h-20 rounded-full bg-rose-200/40 blur-xl"></div>
      <div class="relative w-10 h-10 rounded-xl bg-danger-600 text-white flex items-center justify-center text-base shadow-soft flex-shrink-0">⚠️</div>
      <div class="relative flex-1">
        <div class="text-sm font-bold text-rose-900">Facebook 渠道转化率异常</div>
        <div class="text-xs text-rose-700 mt-1">过去 24 小时点击安装率从 28% 骤降至 18%（-35%），可能与 Meta crawler 缓存失效或 OG 抓取失败有关。建议：</div>
        <ul class="text-xs text-rose-700 mt-1.5 ml-4 list-disc space-y-0.5">
          <li>检查落地页 OG meta 是否完整</li>
          <li>到 SDK 调试工具点击「刷新 FB 缓存」</li>
          <li>查看用户路径定位流失环节</li>
        </ul>
      </div>
      ${UI.ghostBtn("查看详情")}
      <button class="text-rose-300 hover:text-rose-500 text-sm">✕</button>
    </div>

    <!-- 主趋势 -->
    <div class="card p-6 mb-4">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-bold text-ink-900">核心指标趋势 · 14 天</h3>
        <div class="flex items-center gap-1 text-xs p-1 bg-ink-50 rounded-lg">
          <button class="px-3 py-1 rounded-md text-ink-500 hover:bg-white">小时</button>
          <button class="px-3 py-1 rounded-md bg-white text-brand-700 font-semibold shadow-soft">天</button>
          <button class="px-3 py-1 rounded-md text-ink-500 hover:bg-white">周</button>
        </div>
      </div>
      <div id="trend-main" style="height: 340px;"></div>
    </div>

    <!-- 转化率 + 环比 -->
    <div class="grid grid-cols-2 gap-4">
      <div class="card p-6">
        <h3 class="text-sm font-bold text-ink-900 mb-3">总转化率（分享 → 付费）</h3>
        <div id="trend-rate" style="height: 260px;"></div>
      </div>
      <div class="card p-6">
        <h3 class="text-sm font-bold text-ink-900 mb-4">环比对比 · 昨日 vs 前日</h3>
        <div class="space-y-3">
          ${[
            { name: "分享次数", curr: 12890, prev: 11876, color: "brand" },
            { name: "点击次数", curr: 3867, prev: 3563, color: "blue" },
            { name: "新增安装", curr: 968, prev: 890, color: "green" },
            { name: "新增付费", curr: 129, prev: 118, color: "amber" },
          ].map(m => {
            const diff = (((m.curr - m.prev) / m.prev) * 100).toFixed(1);
            const dotColor = { brand: "bg-brand-500", blue: "bg-cyan-500", green: "bg-emerald-500", amber: "bg-amber-500" }[m.color];
            return `
              <div class="flex items-center gap-3 py-2 border-b border-ink-100 last:border-0">
                <span class="w-2 h-2 rounded-full ${dotColor}"></span>
                <div class="flex-1">
                  <div class="text-xs text-ink-500">${m.name}</div>
                  <div class="num text-base font-bold mt-0.5">${UI.fmtNum(m.curr)} <span class="text-xs text-ink-400 font-normal">vs ${UI.fmtNum(m.prev)}</span></div>
                </div>
                ${UI.trendArrow(+diff)}
              </div>`;
          }).join("")}
        </div>
      </div>
    </div>
  `;
};

// ---------- 用户路径 ----------
Pages.userPaths = function () {
  return `
    ${UI.pageHeader({ title: "用户路径分析", desc: "查看单个 ref_code 的完整追踪链路 · 从分享到付费", icon: "🔗" })}

    <!-- 搜索 -->
    <div class="card p-5 mb-4 flex items-end gap-3">
      <div class="flex-1">
        <label class="block text-xs text-ink-500 mb-1.5">输入 ref_code 或分享者用户 ID</label>
        <input type="text" value="ref_a9f3ce2b8d" class="w-full px-3 py-2.5 border border-ink-200 rounded-xl text-sm font-mono focus:border-brand-500 focus:ring-2 focus:ring-brand-100 outline-none" />
      </div>
      ${UI.primaryBtn("🔍 查询", { onclick: "UI.toast('已加载路径', 'info')" })}
    </div>

    <!-- 路径概览 -->
    <div class="grid grid-cols-4 gap-3 mb-4">
      ${UI.statCard({ label: "ref_code", value: '<span class="font-mono text-sm">ref_a9f3ce2b8d</span>', delta: 0, icon: "🔗", color: "brand" })}
      ${UI.statCard({ label: "分享时间", value: "05-10 14:30", delta: 0, icon: "🕐", color: "blue" })}
      ${UI.statCard({ label: "总耗时", value: "2 天 35 分", delta: 0, icon: "⏱", color: "amber" })}
      ${UI.statCard({ label: "最终状态", value: "已付费 ✓", delta: 0, icon: "💰", color: "green" })}
    </div>

    <!-- 路径时间线 -->
    <div class="grid grid-cols-3 gap-4">
      <div class="col-span-2 card p-6">
        <h3 class="text-sm font-bold text-ink-900 mb-1">完整事件链路</h3>
        <p class="text-xs text-ink-500 mb-5">用户 A 分享 → 好友 B 注册并付费</p>

        <div class="relative">
          <div class="absolute left-4 top-2 bottom-2 w-0.5 bg-brand-700 rounded-full"></div>
          <div class="space-y-4">
            ${MOCK.USER_PATH_EXAMPLE.map((p, i) => `
              <div class="relative flex gap-4 group">
                <div class="w-9 h-9 rounded-xl ${p.highlight ? "bg-ok-600" : "bg-brand-900"} text-white flex items-center justify-center text-sm font-bold flex-shrink-0 z-10 shadow-soft ring-2 ring-white">${i + 1}</div>
                <div class="flex-1 bg-ink-50 rounded-xl p-3 group-hover:from-brand-50 transition">
                  <div class="flex items-center justify-between">
                    <div class="text-sm font-bold text-ink-900 flex items-center gap-2">
                      <span class="text-base">${p.icon || "📍"}</span>
                      ${p.event}
                      ${p.highlight ? '<span class="badge bg-emerald-100 text-emerald-700">付费成功</span>' : ""}
                    </div>
                    <div class="text-xs text-ink-400 num">${p.time}</div>
                  </div>
                  <div class="text-xs text-ink-500 mt-1">${p.desc}</div>
                  ${p.delay ? `<div class="text-[11px] text-ink-400 mt-1 num">⏱ 耗时 ${p.delay}</div>` : ""}
                </div>
              </div>
            `).join("")}
          </div>
        </div>
      </div>

      <div class="card p-5">
        <h3 class="text-sm font-bold text-ink-900 mb-3">📋 路径元信息</h3>
        <div class="space-y-3 text-xs">
          ${metaRow("分享者", "user_a_3219", "mono")}
          ${metaRow("渠道", "📘 Facebook")}
          ${metaRow("UTM 来源", "facebook / social / spring_2026", "mono")}
          ${metaRow("归因方式", "设备指纹匹配 · 96% 置信度")}
          ${metaRow("设备地区", "🇺🇸 美国 · 加州")}
          <div class="pt-3 border-t border-ink-100">
            <div class="text-ink-500">付费金额</div>
            <div class="num text-2xl font-extrabold text-emerald-600 mt-1">$9.99 <span class="text-xs text-ink-400 font-normal">USD</span></div>
          </div>
        </div>
      </div>
    </div>
  `;
};
function metaRow(label, value, type = "") {
  return `
    <div>
      <div class="text-ink-500">${label}</div>
      <div class="text-ink-900 mt-0.5 ${type === "mono" ? "font-mono text-[11px]" : ""}">${value}</div>
    </div>
  `;
}

// ---------- 数据导出 ----------
Pages.dataExport = function () {
  return `
    ${UI.pageHeader({ title: "数据导出", desc: "支持 CSV / JSON / PDF 三种格式，按需导出", icon: "📥" })}

    <div class="grid grid-cols-3 gap-4 mb-6">
      ${[
        { type: "CSV", icon: "📊", desc: "适合 Excel / Numbers 二次分析", gradient: "from-ok-500 to-brand-700" },
        { type: "JSON", icon: "🔧", desc: "适合程序化处理 / 接入其他系统", gradient: "from-brand-600 to-brand-700" },
        { type: "PDF", icon: "📄", desc: "适合周报 / 月报 / 团队汇报", gradient: "from-warn-500 to-brand-700" },
      ].map(f => `
        <div onclick="confirmAction('生成 ${f.type} 报表', '确定要按当前筛选条件生成 ${f.type} 报表吗？生成任务会进入导出队列，完成后可在历史记录中下载。', '确认生成', '已开始生成 ${f.type} 报表', '', 'info')" class="card card-hover cursor-pointer p-6 relative overflow-hidden">
          <div class="absolute -right-4 -top-4 w-24 h-24 rounded-full opacity-10 bg-ink-100"></div>
          <div class="w-14 h-14 rounded-2xl bg-ink-100 flex items-center justify-center text-2xl mb-3 shadow-soft text-white">${f.icon}</div>
          <div class="text-base font-bold text-ink-900">导出 ${f.type}</div>
          <div class="text-xs text-ink-500 mt-1">${f.desc}</div>
          <button class="mt-4 px-3 py-1.5 text-xs bg-brand-50 text-brand-700 rounded-lg hover:bg-brand-100 font-medium">立即导出 →</button>
        </div>
      `).join("")}
    </div>

    <!-- 自定义范围 -->
    <div class="card p-6 mb-6">
      <h3 class="text-sm font-bold text-ink-900 mb-4">自定义导出范围</h3>
      <div class="grid grid-cols-2 gap-6">
        <div class="space-y-4">
          <div>
            <label class="block text-xs text-ink-500 mb-2">数据范围</label>
            <div class="space-y-2">
              ${["漏斗明细数据", "渠道对比数据", "用户路径数据", "原始事件日志（需特殊权限）"].map((item, i) => `
                <label class="flex items-center gap-2.5 cursor-pointer p-2 rounded-lg hover:bg-ink-50">
                  <input type="checkbox" ${i < 2 ? "checked" : ""} ${i === 3 ? "disabled" : ""} class="w-4 h-4 rounded border-ink-300 text-brand-500" />
                  <span class="text-sm ${i === 3 ? "text-ink-300" : "text-ink-700"}">${item}</span>
                  ${i === 3 ? '<span class="text-[10px] text-ink-300 ml-auto">SDK 管理员</span>' : ""}
                </label>
              `).join("")}
            </div>
          </div>
          <div>
            <label class="block text-xs text-ink-500 mb-1.5">时间范围</label>
            <select class="w-full px-3 py-2 border border-ink-200 rounded-xl text-sm bg-white">
              <option>最近 7 天</option>
              <option>最近 30 天</option>
              <option>最近 90 天</option>
              <option>自定义</option>
            </select>
          </div>
        </div>
        <div class="space-y-4">
          <div>
            <label class="block text-xs text-ink-500 mb-1.5">游戏</label>
            <select class="w-full px-3 py-2 border border-ink-200 rounded-xl text-sm bg-white">
              <option>全部我有权限的游戏</option>
              ${MOCK.GAMES.map(g => `<option>${g.name}</option>`).join("")}
            </select>
          </div>
          <div>
            <label class="block text-xs text-ink-500 mb-1.5">数据粒度</label>
            <div class="flex gap-2">
              <button class="flex-1 px-3 py-2 border border-brand-500 bg-brand-50 text-brand-700 rounded-xl text-sm font-medium">按天</button>
              <button class="flex-1 px-3 py-2 border border-ink-200 rounded-xl text-sm hover:border-brand-300">按小时</button>
              <button class="flex-1 px-3 py-2 border border-ink-200 rounded-xl text-sm hover:border-brand-300">按分钟</button>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-6 pt-5 border-t border-ink-100 flex justify-end gap-2">
        ${UI.ghostBtn("保存为模板")}
        ${UI.primaryBtn("📥 立即导出", { onclick: "UI.toast('开始导出，邮件将发送至您的邮箱', 'success')" })}
      </div>
    </div>

    <!-- 历史导出 -->
    <div class="card overflow-hidden">
      <div class="px-6 py-4 border-b border-ink-100">
        <h3 class="text-sm font-bold text-ink-900">导出历史</h3>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-6 py-3 font-semibold">名称</th>
            <th class="text-left px-4 py-3 font-semibold">格式</th>
            <th class="text-left px-4 py-3 font-semibold">时间范围</th>
            <th class="text-left px-4 py-3 font-semibold">状态</th>
            <th class="text-left px-4 py-3 font-semibold">创建时间</th>
            <th class="text-right px-6 py-3 font-semibold">操作</th>
          </tr>
        </thead>
        <tbody>
          ${[
            { name: "王者征途_漏斗_最近7天", fmt: "CSV", range: "2026-05-08 ~ 05-15", status: "completed", time: "05-15 14:32", size: "2.4 MB" },
            { name: "全游戏_渠道对比_5月", fmt: "PDF", range: "2026-05-01 ~ 05-31", status: "completed", time: "05-15 10:18", size: "880 KB" },
            { name: "梦幻西游_用户路径_5/14", fmt: "JSON", range: "2026-05-14", status: "processing", time: "05-15 17:50", size: "—" },
          ].map(r => `
            <tr class="border-t border-ink-100 row-hover">
              <td class="px-6 py-3">${r.name}</td>
              <td class="px-4 py-3"><span class="badge bg-cyan-50 text-cyan-700">${r.fmt}</span></td>
              <td class="px-4 py-3 text-ink-500 text-xs num">${r.range}</td>
              <td class="px-4 py-3">${r.status === "completed" ? '<span class="badge bg-emerald-50 text-emerald-700"><span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>已完成</span>' : '<span class="badge bg-amber-50 text-amber-700"><span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse-soft"></span>生成中</span>'}</td>
              <td class="px-4 py-3 text-ink-500 text-xs num">${r.time}</td>
              <td class="px-6 py-3 text-right">
                ${r.status === "completed" ? `<button class="text-xs text-brand-700 hover:underline font-medium">下载 (${r.size})</button>` : '<span class="text-xs text-ink-300">请稍候</span>'}
              </td>
            </tr>`).join("")}
        </tbody>
      </table>
    </div>
  `;
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).addDateDays = addDateDays;
;(window as any).buildActivityRetentionRows = buildActivityRetentionRows;
;(window as any).buildAnalyticsActiveLevelDistribution = buildAnalyticsActiveLevelDistribution;
;(window as any).buildAnalyticsDeviceModelDistribution = buildAnalyticsDeviceModelDistribution;
;(window as any).buildAnalyticsGameDistribution = buildAnalyticsGameDistribution;
;(window as any).buildAnalyticsInstallAgeDistribution = buildAnalyticsInstallAgeDistribution;
;(window as any).buildAnalyticsLanguageDistribution = buildAnalyticsLanguageDistribution;
;(window as any).buildAnalyticsLanguageRankRows = buildAnalyticsLanguageRankRows;
;(window as any).buildAnalyticsMemoryDistribution = buildAnalyticsMemoryDistribution;
;(window as any).buildAnalyticsOsVersionDistribution = buildAnalyticsOsVersionDistribution;
;(window as any).buildAnalyticsOverviewMetrics = buildAnalyticsOverviewMetrics;
;(window as any).buildAnalyticsOverviewRateTrend = buildAnalyticsOverviewRateTrend;
;(window as any).buildAnalyticsPackageDistribution = buildAnalyticsPackageDistribution;
;(window as any).buildAnalyticsPlatformDistribution = buildAnalyticsPlatformDistribution;
;(window as any).buildAnalyticsPlatformRankRows = buildAnalyticsPlatformRankRows;
;(window as any).buildAnalyticsRegionDistribution = buildAnalyticsRegionDistribution;
;(window as any).buildAnalyticsRegionRows = buildAnalyticsRegionRows;
;(window as any).buildAnalyticsShareFrequencyDistribution = buildAnalyticsShareFrequencyDistribution;
;(window as any).buildAnalyticsWeightedDistribution = buildAnalyticsWeightedDistribution;
;(window as any).buildShareDataCountryRows = buildShareDataCountryRows;
;(window as any).buildShareDataDeviceModelRows = buildShareDataDeviceModelRows;
;(window as any).buildShareDataLanguageRows = buildShareDataLanguageRows;
;(window as any).buildShareDataRows = buildShareDataRows;
;(window as any).buildShareDataSceneRows = buildShareDataSceneRows;
;(window as any).buildShareDataWeightedBreakdownRows = buildShareDataWeightedBreakdownRows;
;(window as any).calculateAnalyticsRankRates = calculateAnalyticsRankRates;
;(window as any).createShareDataBreakdownRow = createShareDataBreakdownRow;
;(window as any).daysBetween = daysBetween;
;(window as any).filterChip = filterChip;
;(window as any).formatDateOnly = formatDateOnly;
;(window as any).formatMonthDay = formatMonthDay;
;(window as any).getAnalyticsGamePackages = getAnalyticsGamePackages;
;(window as any).getAnalyticsOverviewSelectedPackageIds = getAnalyticsOverviewSelectedPackageIds;
;(window as any).getAnalyticsOverviewTrendDates = getAnalyticsOverviewTrendDates;
;(window as any).getAnalyticsPackageMetricValue = getAnalyticsPackageMetricValue;
;(window as any).getAnalyticsPackageName = getAnalyticsPackageName;
;(window as any).getAnalyticsPackageRankRows = getAnalyticsPackageRankRows;
;(window as any).getAnalyticsPieMetricMeta = getAnalyticsPieMetricMeta;
;(window as any).getAnalyticsRegions = getAnalyticsRegions;
;(window as any).getAnalyticsSelectedGame = getAnalyticsSelectedGame;
;(window as any).getAnalyticsSelectedGameId = getAnalyticsSelectedGameId;
;(window as any).getCurrentShareDataDetailConfigId = getCurrentShareDataDetailConfigId;
;(window as any).getCurrentShareDataDetailRow = getCurrentShareDataDetailRow;
;(window as any).getDefaultShareDataDetailTimeRange = getDefaultShareDataDetailTimeRange;
;(window as any).getShareDataDetailRangeDates = getShareDataDetailRangeDates;
;(window as any).getShareDataDetailTimeRange = getShareDataDetailTimeRange;
;(window as any).getShareDataFunnelStages = getShareDataFunnelStages;
;(window as any).getShareDataLanguageVersions = getShareDataLanguageVersions;
;(window as any).getShareDataSdkPlatformRows = getShareDataSdkPlatformRows;
;(window as any).highlightCard = highlightCard;
;(window as any).metaRow = metaRow;
;(window as any).parseDateOnly = parseDateOnly;
;(window as any).refreshShareDataDetailAfterTimeChange = refreshShareDataDetailAfterTimeChange;
;(window as any).renderActivityRetentionRow = renderActivityRetentionRow;
;(window as any).renderAnalyticsDistributionPie = renderAnalyticsDistributionPie;
;(window as any).renderAnalyticsFilters = renderAnalyticsFilters;
;(window as any).renderAnalyticsGameRow = renderAnalyticsGameRow;
;(window as any).renderAnalyticsOverviewCharts = renderAnalyticsOverviewCharts;
;(window as any).renderAnalyticsOverviewMetric = renderAnalyticsOverviewMetric;
;(window as any).renderAnalyticsRankRow = renderAnalyticsRankRow;
;(window as any).renderAnalyticsRankTable = renderAnalyticsRankTable;
;(window as any).renderRetentionCell = renderRetentionCell;
;(window as any).renderShareDataBreakdownColgroup = renderShareDataBreakdownColgroup;
;(window as any).renderShareDataBreakdownHeader = renderShareDataBreakdownHeader;
;(window as any).renderShareDataBreakdownRow = renderShareDataBreakdownRow;
;(window as any).renderShareDataChannelRow = renderShareDataChannelRow;
;(window as any).renderShareDataCountryRow = renderShareDataCountryRow;
;(window as any).renderShareDataDetailCharts = renderShareDataDetailCharts;
;(window as any).renderShareDataDetailFunnel = renderShareDataDetailFunnel;
;(window as any).renderShareDataDeviceModelRow = renderShareDataDeviceModelRow;
;(window as any).renderShareDataFunnelNode = renderShareDataFunnelNode;
;(window as any).renderShareDataFunnelSvgChip = renderShareDataFunnelSvgChip;
;(window as any).renderShareDataFunnelSvgLayer = renderShareDataFunnelSvgLayer;
;(window as any).renderShareDataLanguageBadges = renderShareDataLanguageBadges;
;(window as any).renderShareDataLanguageDetailRow = renderShareDataLanguageDetailRow;
;(window as any).renderShareDataLanguageSummaryRow = renderShareDataLanguageSummaryRow;
;(window as any).renderShareDataPackageRow = renderShareDataPackageRow;
;(window as any).renderShareDataRow = renderShareDataRow;
;(window as any).renderShareDataSceneRow = renderShareDataSceneRow;
;(window as any).renderShareDataSdkPlatformSummary = renderShareDataSdkPlatformSummary;
;(window as any).resizeAnalyticsOverviewCharts = resizeAnalyticsOverviewCharts;
;(window as any).scheduleAnalyticsOverviewCharts = scheduleAnalyticsOverviewCharts;
